import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date | string; output: Date | string; }
  DateTime: { input: Date | string; output: Date | string; }
  EmailAddress: { input: string; output: string; }
  JSON: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
};

export type AddTaskClipboardInput = {
  cogarchCourseId: Scalars['String']['input'];
  cogarchTaskId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  requestUserId: Scalars['String']['input'];
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  s3Location: Scalars['String']['input'];
  slideOrder: Scalars['Int']['input'];
};

export type AllocatedProgramMember = {
  __typename?: 'AllocatedProgramMember';
  email: Scalars['String']['output'];
  employeeDetails?: Maybe<EmployeeDetails>;
  id: Scalars['ID']['output'];
  isFirstLogin: Scalars['Boolean']['output'];
  roles?: Maybe<Array<Maybe<Permissions>>>;
};

export type AllocatedTaskMember = {
  __typename?: 'AllocatedTaskMember';
  email: Scalars['String']['output'];
  employeeDetails?: Maybe<EmployeeDetails>;
  id: Scalars['ID']['output'];
  isFirstLogin: Scalars['Boolean']['output'];
};

export type Announcements = {
  __typename?: 'Announcements';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignProgramInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  stsOrganisationId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type AssignTaskInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  stsOrganisationId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type AuditTrail = {
  __typename?: 'AuditTrail';
  actionType: Scalars['String']['output'];
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['ID']['output'];
  entityId: Scalars['ID']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AuditTrailInput = {
  actionType: Scalars['String']['input'];
  changedAt: Scalars['DateTime']['input'];
  changedBy: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
};

export type BubbleButton = {
  __typename?: 'BubbleButton';
  buttonType?: Maybe<BubbleButtonType>;
  depth?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  numchild?: Maybe<Scalars['Int']['output']>;
  operationType?: Maybe<BubbleButtonOperationType>;
  path?: Maybe<Scalars['String']['output']>;
};

export enum BubbleButtonOperationType {
  LoadSub = 'LOAD_SUB',
  OpenLink = 'OPEN_LINK'
}

export enum BubbleButtonType {
  Che = 'CHE',
  Con = 'CON',
  Moo = 'MOO',
  Per = 'PER'
}

export type CaiInstance = {
  __typename?: 'CaiInstance';
  chatId: Scalars['ID']['output'];
  cogarchRole: Scalars['String']['output'];
  currentScope: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  previousBubbleId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type CaiSessionActivity = TaskActivity & {
  __typename?: 'CaiSessionActivity';
  id: Scalars['ID']['output'];
  sessionId: Scalars['String']['output'];
  taskActivityId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: CategoryType;
};

export type CategoryFilter = {
  type?: InputMaybe<CategoryType>;
};

export type CategoryPagination = {
  __typename?: 'CategoryPagination';
  categories?: Maybe<Array<Maybe<Category>>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export enum CategoryType {
  Goal = 'GOAL',
  Program = 'PROGRAM',
  Task = 'TASK'
}

export enum CoachCategory {
  Business = 'BUSINESS',
  Psychology = 'PSYCHOLOGY'
}

export type CreateBubbleButton = {
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  subButtons?: InputMaybe<Array<InputMaybe<CreateBubbleButton>>>;
};

export type CreateCheckoutSessionResponse = {
  __typename?: 'CreateCheckoutSessionResponse';
  sessionId: Scalars['String']['output'];
  sessionUrl: Scalars['String']['output'];
};

export type Documents = {
  __typename?: 'Documents';
  cogarchEmbeddingId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  filePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  s3Location: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};

export type Echelon = {
  __typename?: 'Echelon';
  bu?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  global?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

export enum Education {
  Associate = 'ASSOCIATE',
  Bachelor = 'BACHELOR',
  Diploma = 'DIPLOMA',
  Doctorate = 'DOCTORATE',
  HighSchool = 'HIGH_SCHOOL',
  Master = 'MASTER',
  PhD = 'PhD'
}

export type EmployeeDetails = {
  __typename?: 'EmployeeDetails';
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  highestEducation?: Maybe<Education>;
  hiringDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobDescription?: Maybe<JobDescription>;
  jobDescriptionText?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Array<Maybe<ProgramInstance>>>;
  phone?: Maybe<Scalars['String']['output']>;
  programs?: Maybe<Array<Maybe<OnboardingProgram>>>;
  resume?: Maybe<Scalars['String']['output']>;
  role?: Maybe<WorkingRole>;
  status?: Maybe<EmployeeStatus>;
  teams?: Maybe<Array<Maybe<Team>>>;
  terminationDate?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type EmployeeFilter = {
  roleNames?: InputMaybe<Array<InputMaybe<Role>>>;
  stsUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EmployeeInput = {
  email: Scalars['EmailAddress']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  highestEducation?: InputMaybe<Education>;
  hiringDate?: InputMaybe<Scalars['Date']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  roleID?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EmployeeStatus>;
  teamID?: InputMaybe<Scalars['ID']['input']>;
  terminationDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum EmployeeStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  OnboardingComplete = 'ONBOARDING_COMPLETE',
  OnboardingStarted = 'ONBOARDING_STARTED',
  OnLeave = 'ON_LEAVE',
  Registered = 'REGISTERED',
  Terminated = 'TERMINATED'
}

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IntegrationUserValidationResponse = {
  __typename?: 'IntegrationUserValidationResponse';
  isExist: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  date?: Maybe<Scalars['Date']['output']>;
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<InvitationStatus>;
  text: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Escalated = 'ESCALATED',
  Sent = 'SENT'
}

export type Invoice = {
  __typename?: 'Invoice';
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  originalAmount?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type JobDescription = {
  __typename?: 'JobDescription';
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  qualifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  responsibilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  country: Scalars['String']['output'];
  global?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
  zone?: Maybe<Scalars['String']['output']>;
};

export type MeetingTask = OnboardingTask & {
  __typename?: 'MeetingTask';
  completionWeek?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  meetingType?: Maybe<MeetingType>;
  participants?: Maybe<Array<Maybe<User>>>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum MeetingType {
  Group = 'GROUP',
  Hr = 'HR',
  Manager = 'MANAGER',
  Mentoring = 'MENTORING'
}

export type MentorActivity = TaskActivity & {
  __typename?: 'MentorActivity';
  attachmentId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  instances?: Maybe<Array<Maybe<MentorInstance>>>;
  questions?: Maybe<Array<Maybe<MentorQuestions>>>;
  taskActivityId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type MentorActivityInput = {
  id: Scalars['ID']['input'];
  questions?: InputMaybe<Array<InputMaybe<MentorQuestionsInput>>>;
};

export type MentorInstance = {
  __typename?: 'MentorInstance';
  chatId: Scalars['ID']['output'];
  cogarchRole: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  currentQuiz: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastActivity: Scalars['DateTime']['output'];
  mentorActivityId: Scalars['ID']['output'];
  quizzes?: Maybe<Array<Maybe<Quiz>>>;
  taskInstanceId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type MentorInstanceQuizAnswer = {
  mentorInstanceId: Scalars['ID']['input'];
  providedAnswer: Scalars['String']['input'];
  quizId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MentorQuestions = {
  __typename?: 'MentorQuestions';
  correct_answer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incorrect_answers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  quiz_id: Scalars['String']['output'];
};

export type MentorQuestionsInput = {
  correct_answer: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  incorrect_answers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  quiz_id?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addTaskClipboard?: Maybe<UpdateResponse>;
  addUserToOrganisation?: Maybe<UpdateResponse>;
  addUserToTeam?: Maybe<UpdateResponse>;
  answerMentorInstanceQuiz?: Maybe<UpdateResponse>;
  assignProgram?: Maybe<UpdateResponse>;
  assignTask?: Maybe<UpdateResponse>;
  changeStatusOrganization?: Maybe<UpdateResponse>;
  completeTaskActivity?: Maybe<UpdateResponse>;
  createBubbleButton?: Maybe<UpdateResponse>;
  createSubscription: CreateCheckoutSessionResponse;
  deleteCategory?: Maybe<UpdateResponse>;
  deleteDocument?: Maybe<UpdateResponse>;
  deleteOrganization?: Maybe<UpdateResponse>;
  deleteProgram?: Maybe<UpdateResponse>;
  deleteStarterProgram?: Maybe<UpdateResponse>;
  deleteTask?: Maybe<UpdateResponse>;
  deleteTeam?: Maybe<UpdateResponse>;
  deleteUser?: Maybe<UpdateResponse>;
  generatePresignedDeleteUrl: PresignedUrlResponse;
  generatePresignedGetUrl: PresignedUrlResponse;
  generatePresignedPutUrl: PresignedUrlResponse;
  promoteOrDemoteUserInTeam?: Maybe<UpdateResponse>;
  publishProgram?: Maybe<UpdateResponse>;
  purchaseAdditionalSeats: CreateCheckoutSessionResponse;
  purchaseTokenPack: PurchaseTokenPackResponse;
  registerUser?: Maybe<UpdateResponse>;
  removeUserFromOrganisation?: Maybe<UpdateResponse>;
  removeUserFromTeam?: Maybe<UpdateResponse>;
  reorderIncludedTasks: UpdateResponse;
  resetUserToDemoState?: Maybe<UpdateResponse>;
  retakeTask?: Maybe<UpdateResponse>;
  saveCategory?: Maybe<UpdateResponse>;
  saveCompany?: Maybe<UpdateResponse>;
  saveProgram?: Maybe<UpdateResponse>;
  saveStarterProgram?: Maybe<UpdateResponse>;
  saveTask?: Maybe<UpdateResponse>;
  saveTaskDetails?: Maybe<UpdateResponse>;
  saveTeam?: Maybe<UpdateResponse>;
  saveUser?: Maybe<UpdateResponse>;
  scheduleDowngradeSubscription: UpdateResponse;
  transferTeamOwnership?: Maybe<UpdateResponse>;
  unassignProgram?: Maybe<UpdateResponse>;
  updateCaiInstance?: Maybe<UpdateResponse>;
  updateCurrentSlideNumber?: Maybe<UpdateResponse>;
  updateDocument?: Maybe<UpdateResponse>;
  updateDocumentFilePath?: Maybe<UpdateResponse>;
  updateOrganization?: Maybe<UpdateResponse>;
  updatePreviousBubbleId?: Maybe<UpdateResponse>;
  updateProgramTaskStatus?: Maybe<UpdateResponse>;
  updateTaskInstanceResetFlag?: Maybe<UpdateResponse>;
  updateUserRole?: Maybe<UpdateResponse>;
  uploadDocuments?: Maybe<UpdateResponse>;
  upsertUserSetting?: Maybe<UpdateResponse>;
  upsertUserSettings?: Maybe<UpdateResponse>;
  validateIntegrationUser?: Maybe<IntegrationUserValidationResponse>;
};


export type MutationAddTaskClipboardArgs = {
  data?: InputMaybe<Array<InputMaybe<AddTaskClipboardInput>>>;
};


export type MutationAddUserToOrganisationArgs = {
  stsOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  stsUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddUserToTeamArgs = {
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userIdToAdd: Scalars['ID']['input'];
};


export type MutationAnswerMentorInstanceQuizArgs = {
  input: MentorInstanceQuizAnswer;
};


export type MutationAssignProgramArgs = {
  input?: InputMaybe<AssignProgramInput>;
};


export type MutationAssignTaskArgs = {
  input?: InputMaybe<AssignTaskInput>;
};


export type MutationChangeStatusOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationCompleteTaskActivityArgs = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  activityInstanceId?: InputMaybe<Scalars['ID']['input']>;
  activityType: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBubbleButtonArgs = {
  input?: InputMaybe<CreateBubbleButton>;
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateSubscriptionArgs = {
  desiredSeats: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  planType?: InputMaybe<OrganizationUsagePlan>;
};


export type MutationDeleteCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteProgramArgs = {
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteStarterProgramArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  roleId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userIdToDelete: Scalars['ID']['input'];
};


export type MutationGeneratePresignedDeleteUrlArgs = {
  existingKey: Scalars['String']['input'];
};


export type MutationGeneratePresignedGetUrlArgs = {
  existingKey: Scalars['String']['input'];
};


export type MutationGeneratePresignedPutUrlArgs = {
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
};


export type MutationPromoteOrDemoteUserInTeamArgs = {
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userIdToUpdate: Scalars['ID']['input'];
};


export type MutationPublishProgramArgs = {
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationPurchaseAdditionalSeatsArgs = {
  desiredSeats: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationPurchaseTokenPackArgs = {
  organizationId: Scalars['ID']['input'];
  tokenAmount: Scalars['Int']['input'];
};


export type MutationRegisterUserArgs = {
  input: UserRegistrationInput;
};


export type MutationRemoveUserFromOrganisationArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromTeamArgs = {
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userIdToRemove: Scalars['ID']['input'];
};


export type MutationReorderIncludedTasksArgs = {
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  taskOrders: Array<TaskOrderInput>;
  userId: Scalars['ID']['input'];
};


export type MutationResetUserToDemoStateArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRetakeTaskArgs = {
  taskId: Scalars['ID']['input'];
  taskInstanceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveCategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<SaveCategoryInput>;
};


export type MutationSaveCompanyArgs = {
  input?: InputMaybe<SaveCompanyInput>;
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveProgramArgs = {
  input?: InputMaybe<SaveProgramInput>;
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveStarterProgramArgs = {
  input?: InputMaybe<SaveStarterProgramInput>;
};


export type MutationSaveTaskArgs = {
  input?: InputMaybe<SaveTaskInput>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveTaskDetailsArgs = {
  input?: InputMaybe<SaveTaskDetailsInput>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveTeamArgs = {
  input?: InputMaybe<SaveTeamInput>;
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSaveUserArgs = {
  input?: InputMaybe<SaveUserInput>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationScheduleDowngradeSubscriptionArgs = {
  organizationId: Scalars['ID']['input'];
  targetPlan: OrganizationUsagePlan;
};


export type MutationTransferTeamOwnershipArgs = {
  newOwnerId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUnassignProgramArgs = {
  input?: InputMaybe<UnassignProgramInput>;
};


export type MutationUpdateCaiInstanceArgs = {
  input?: InputMaybe<UpdateCaiInstanceInput>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateCurrentSlideNumberArgs = {
  presentationActivityId: Scalars['ID']['input'];
  presentationInstanceId: Scalars['ID']['input'];
  slideNumber: Scalars['Int']['input'];
};


export type MutationUpdateDocumentArgs = {
  documentId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
  roleId: Scalars['ID']['input'];
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  s3Location: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateDocumentFilePathArgs = {
  documentId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdatePreviousBubbleIdArgs = {
  bubbleId?: InputMaybe<Scalars['String']['input']>;
  caiInstanceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateProgramTaskStatusArgs = {
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  target: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdateTaskInstanceResetFlagArgs = {
  taskInstanceId: Scalars['ID']['input'];
};


export type MutationUpdateUserRoleArgs = {
  employeeId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};


export type MutationUploadDocumentsArgs = {
  documents?: InputMaybe<Array<InputMaybe<UploadDocumentsRequest>>>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpsertUserSettingArgs = {
  organizationId: Scalars['ID']['input'];
  settingKey: Scalars['String']['input'];
  settingValue: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  userSettingId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertUserSettingsArgs = {
  settings: Array<InputMaybe<UserSettingsInput>>;
};


export type MutationValidateIntegrationUserArgs = {
  organizationId: Scalars['ID']['input'];
};

export type OnboardingProgram = {
  __typename?: 'OnboardingProgram';
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Maybe<OnboardingTask>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OnboardingProgramInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  lastUpdated?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardingTask = {
  completionWeek?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type OnboardingTaskInput = {
  completionWeek?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lastUpdated?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  category: OrganizationCategory;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  documentCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  invoices: Array<Invoice>;
  lastResetDate?: Maybe<Scalars['DateTime']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  stripeUpgradePrompt?: Maybe<StripeUpgradePrompt>;
  stsOrganisationId?: Maybe<Scalars['String']['output']>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  type?: Maybe<OrganizationType>;
  usagePlan: OrganizationUsagePlan;
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  workspaceCost: Scalars['Float']['output'];
};

export enum OrganizationCategory {
  All = 'All',
  Community = 'Community',
  Company = 'Company',
  Family = 'Family',
  Government = 'Government',
  Ngo = 'NGO',
  Personal = 'Personal'
}

export type OrganizationFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  markDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notCategory?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationPagination = {
  __typename?: 'OrganizationPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export enum OrganizationType {
  Customer = 'CUSTOMER',
  Master = 'MASTER'
}

export enum OrganizationUsagePlan {
  Explore = 'EXPLORE',
  Grow = 'GROW',
  Scaleup = 'SCALEUP',
  Super = 'SUPER'
}

export enum Permission {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type Permissions = {
  __typename?: 'Permissions';
  organizationId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  workingRoles: Array<WorkingRole>;
};

export type PresentationActivity = TaskActivity & {
  __typename?: 'PresentationActivity';
  attachmentId?: Maybe<Scalars['ID']['output']>;
  context?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  dialogue?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  instances?: Maybe<Array<Maybe<PresentationInstance>>>;
  lastUpdatedBy: Scalars['ID']['output'];
  lastUpdatedDialogue?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['ID']['output'];
  slides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskActivityId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PresentationActivityInput = {
  dialogue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  slides?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PresentationInstance = {
  __typename?: 'PresentationInstance';
  chatId: Scalars['ID']['output'];
  cogarchRole: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  currentSlide: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastActivity: Scalars['DateTime']['output'];
  presentationActivityId: Scalars['ID']['output'];
  taskInstanceId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type PresentationTask = OnboardingTask & {
  __typename?: 'PresentationTask';
  completionWeek?: Maybe<Scalars['Int']['output']>;
  context?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  slides?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PresignedUrlResponse = {
  __typename?: 'PresignedUrlResponse';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  allocatedProgramMembers?: Maybe<Array<Maybe<AllocatedProgramMember>>>;
  allocatedTaskMembers?: Maybe<Array<Maybe<AllocatedTaskMember>>>;
  buildStatus?: Maybe<ProgramBuildStatus>;
  categories?: Maybe<Array<Maybe<Category>>>;
  countingTaskStatus?: Maybe<TaskStatusCount>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  numberOfTasks?: Maybe<Scalars['Int']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  programInstance?: Maybe<ProgramInstance>;
  status?: Maybe<ProgramStatus>;
  taskStatus?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  version?: Maybe<Scalars['String']['output']>;
};

export enum ProgramBuildStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum ProgramBuilderColumns {
  All = 'ALL',
  Included = 'INCLUDED',
  Selected = 'SELECTED'
}

export type ProgramFilter = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creatorId?: InputMaybe<Scalars['String']['input']>;
  employeeUserId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProgramStatus>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramInstance = {
  __typename?: 'ProgramInstance';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<ProgramPriority>;
  programId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export enum ProgramPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum ProgramStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotAttributed = 'NOT_ATTRIBUTED',
  ToDo = 'TO_DO'
}

export type ProgramTask = {
  __typename?: 'ProgramTask';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<TaskPriority>;
  programId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ProgramTaskStatus>;
  taskId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum ProgramTaskStatus {
  Assigned = 'ASSIGNED',
  Draft = 'DRAFT'
}

export type ProgressTrackerFilter = {
  taskStatus?: InputMaybe<TaskStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PurchaseTokenPackResponse = {
  __typename?: 'PurchaseTokenPackResponse';
  sessionId: Scalars['String']['output'];
  sessionUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  announcements?: Maybe<Announcements>;
  assignedTasksByProgram?: Maybe<Array<Maybe<TaskWithAssignee>>>;
  caiInstance?: Maybe<CaiInstance>;
  categories?: Maybe<CategoryPagination>;
  documents?: Maybe<Array<Maybe<Documents>>>;
  employee?: Maybe<User>;
  employees?: Maybe<Array<Maybe<User>>>;
  groups?: Maybe<Array<Maybe<Group>>>;
  invoices: Array<Invoice>;
  latestOrganizationInvoice?: Maybe<Invoice>;
  locations?: Maybe<Array<Maybe<Location>>>;
  me?: Maybe<User>;
  organization?: Maybe<Organization>;
  organizationByStsId?: Maybe<Organization>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  paginatedOrganizations?: Maybe<OrganizationPagination>;
  program?: Maybe<Program>;
  programCategories?: Maybe<Array<Maybe<Category>>>;
  programs?: Maybe<Array<Maybe<Program>>>;
  programsInProgressTracker?: Maybe<Array<Maybe<Program>>>;
  quizStatistic?: Maybe<QuizStatistic>;
  starterPrograms?: Maybe<StarterProgramPagination>;
  task?: Maybe<TaskResult>;
  taskCategories?: Maybe<Array<Maybe<Category>>>;
  tasks?: Maybe<TaskPagination>;
  tasksAssignedToUser?: Maybe<Array<Maybe<TaskWithAssignee>>>;
  tasksByProgram?: Maybe<TaskProgram>;
  teams?: Maybe<Array<Maybe<Team>>>;
  tokenPackCost: TokenPackCost;
  treeDocuments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  userDailyTokenUsage?: Maybe<UserDailyTokenUsage>;
  userOrganizations?: Maybe<Array<Maybe<UserOrganization>>>;
  userSettings?: Maybe<Array<Maybe<UserSettings>>>;
  userTeams?: Maybe<Array<Maybe<Team>>>;
  workingRoles?: Maybe<Array<Maybe<WorkingRole>>>;
  workspaceCost: Scalars['Float']['output'];
};


export type QueryAnnouncementsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryAssignedTasksByProgramArgs = {
  filter?: InputMaybe<TaskProgramFilter>;
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryCaiInstanceArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryCategoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CategoryFilter>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeesArgs = {
  filter?: InputMaybe<EmployeeFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryLatestOrganizationInvoiceArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationByStsIdArgs = {
  stsOrganisationId: Scalars['ID']['input'];
};


export type QueryPaginatedOrganizationsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationFilter>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProgramArgs = {
  programId: Scalars['ID']['input'];
  programInstanceId?: InputMaybe<Scalars['ID']['input']>;
  roleId: Scalars['ID']['input'];
};


export type QueryProgramsArgs = {
  filter?: InputMaybe<ProgramFilter>;
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryProgramsInProgressTrackerArgs = {
  filter?: InputMaybe<ProgressTrackerFilter>;
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryQuizStatisticArgs = {
  activityId: Scalars['ID']['input'];
  activityInstanceId: Scalars['ID']['input'];
  taskInstanceId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryStarterProgramsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskArgs = {
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  taskInstanceId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TaskFilter>;
  organizationId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  roleId: Scalars['ID']['input'];
};


export type QueryTasksAssignedToUserArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryTasksByProgramArgs = {
  filter?: InputMaybe<TaskProgramFilter>;
  organizationId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  filter?: InputMaybe<TeamFilter>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTokenPackCostArgs = {
  tokenAmount: Scalars['Int']['input'];
};


export type QueryTreeDocumentsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryUserDailyTokenUsageArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryUserOrganizationsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserSettingsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryWorkspaceCostArgs = {
  memberCount: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  usagePlan?: InputMaybe<OrganizationUsagePlan>;
};

export type Quiz = {
  __typename?: 'Quiz';
  answers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  correctAnswer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mentorInstanceId: Scalars['ID']['output'];
  noOfAttempts: Scalars['Int']['output'];
  passed?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  providedAnswer?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type QuizStatistic = {
  __typename?: 'QuizStatistic';
  data?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalNumberOfQuizzes?: Maybe<Scalars['Int']['output']>;
};

export type Resume = {
  __typename?: 'Resume';
  certifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  education?: Maybe<Array<Maybe<Education>>>;
  id: Scalars['ID']['output'];
  skills?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workExperience?: Maybe<Array<Maybe<WorkExperience>>>;
};

export enum Role {
  Educator = 'EDUCATOR',
  Employee = 'EMPLOYEE',
  Hr = 'HR',
  It = 'IT',
  Manager = 'MANAGER'
}

export type SaveCategoryInput = {
  name: Scalars['String']['input'];
  type: CategoryType;
};

export type SaveCompanyInput = {
  category: Scalars['String']['input'];
  city: Scalars['String']['input'];
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  industry: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  parentCompany?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProgramInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type SaveStarterProgramInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
  organizationType: OrganizationCategory;
  programIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaveTaskDetailsInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  coachCategory?: InputMaybe<CoachCategory>;
  isDuplicate?: Scalars['Boolean']['input'];
  mentorActivities?: InputMaybe<Array<InputMaybe<MentorActivityInput>>>;
  presentationActivities?: InputMaybe<Array<InputMaybe<PresentationActivityInput>>>;
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
  taskTitle: Scalars['String']['input'];
};

export type SaveTaskInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  coachCategory?: InputMaybe<CoachCategory>;
  cogarchCourseId?: InputMaybe<Scalars['String']['input']>;
  cogarchTaskId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  s3Location?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<TaskType>;
};

export type SaveTeamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
};

export type SaveUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  joiningDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Array<Scalars['String']['input']>>;
  permission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stsOrganisationId?: InputMaybe<Scalars['String']['input']>;
  stsUserId: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['String']['input']>;
};

export type StarterProgram = {
  __typename?: 'StarterProgram';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  organizationType: OrganizationCategory;
  programIds?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StarterProgramPagination = {
  __typename?: 'StarterProgramPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  starterPrograms?: Maybe<Array<Maybe<StarterProgram>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export type StripeUpgradePrompt = {
  __typename?: 'StripeUpgradePrompt';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gracePeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  currentCycleAmount?: Maybe<Scalars['Float']['output']>;
  currentPeriodEnd?: Maybe<Scalars['Int']['output']>;
  currentPeriodStart?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateToBeDowngraded?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastInvoiceUrl?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['Int']['output']>;
  nextCycleAmount?: Maybe<Scalars['Float']['output']>;
  reserveTokens: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscribedSeats: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type Task = {
  __typename?: 'Task';
  activities?: Maybe<Array<Maybe<TaskActivity>>>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  coachCategory?: Maybe<CoachCategory>;
  cogarchCourseId?: Maybe<Scalars['String']['output']>;
  cogarchTaskId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInActive?: Maybe<Scalars['Boolean']['output']>;
  isReset?: Maybe<Scalars['Boolean']['output']>;
  isTaskAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastSequence?: Maybe<Scalars['Int']['output']>;
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  s3Location?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type TaskActivity = {
  id: Scalars['ID']['output'];
  taskActivityId: Scalars['ID']['output'];
};

export type TaskAssignee = {
  __typename?: 'TaskAssignee';
  email: Scalars['String']['output'];
  employeeDetails?: Maybe<EmployeeDetails>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars['ID']['output'];
  isFirstLogin: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TaskStatus>;
  teams?: Maybe<Array<Maybe<Team>>>;
};

export type TaskFilter = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TaskInstance = {
  __typename?: 'TaskInstance';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<TaskStatus>;
  task?: Maybe<Task>;
  team?: Maybe<Team>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type TaskOrderInput = {
  order: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
};

export type TaskPagination = {
  __typename?: 'TaskPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  totalItems?: Maybe<Scalars['Int']['output']>;
};

export enum TaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type TaskProgram = {
  __typename?: 'TaskProgram';
  allTasks?: Maybe<Array<Maybe<Task>>>;
  includedTasks?: Maybe<Array<Maybe<Task>>>;
  selectedTasks?: Maybe<Array<Maybe<Task>>>;
};

export type TaskProgramFilter = {
  jobTitleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taskCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taskName?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type TaskResult = Task | TaskWithAssignee;

export enum TaskStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NoStarted = 'NO_STARTED',
  Paused = 'PAUSED',
  Started = 'STARTED',
  ToDo = 'TO_DO'
}

export type TaskStatusCount = {
  __typename?: 'TaskStatusCount';
  completed?: Maybe<Scalars['Int']['output']>;
  inProgress?: Maybe<Scalars['Int']['output']>;
  toDo?: Maybe<Scalars['Int']['output']>;
};

export enum TaskType {
  CaiSession = 'CAI_SESSION',
  Course = 'COURSE'
}

export type TaskWithAssignee = {
  __typename?: 'TaskWithAssignee';
  activities?: Maybe<Array<Maybe<TaskActivity>>>;
  assignee?: Maybe<TaskAssignee>;
  attachmentIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  cogarchCourseId?: Maybe<Scalars['String']['output']>;
  cogarchTaskId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInActive?: Maybe<Scalars['Boolean']['output']>;
  isReset?: Maybe<Scalars['Boolean']['output']>;
  isTaskAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastSequence?: Maybe<Scalars['Int']['output']>;
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskInstanceId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TaskType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type Team = {
  __typename?: 'Team';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hr?: Maybe<User>;
  id: Scalars['ID']['output'];
  markDeleted?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Maybe<TeamUserDetails>>>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  owner?: Maybe<User>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamFilter = {
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  userDetailId?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamUserDetails = {
  __typename?: 'TeamUserDetails';
  email: Scalars['String']['output'];
  employeeDetails?: Maybe<EmployeeDetails>;
  id: Scalars['ID']['output'];
  isManager: Scalars['Boolean']['output'];
  memberId: Scalars['ID']['output'];
  roles?: Maybe<Array<Maybe<Permissions>>>;
  stsUserId?: Maybe<Scalars['ID']['output']>;
};

export type TokenPackCost = {
  __typename?: 'TokenPackCost';
  lineItems: Array<TokenPackLineItem>;
  tokenAmount: Scalars['Int']['output'];
  totalCost: Scalars['Float']['output'];
};

export type TokenPackLineItem = {
  __typename?: 'TokenPackLineItem';
  cost: Scalars['Float']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  tokenAmount: Scalars['Int']['output'];
};

export type UnassignProgramInput = {
  employeeUserId?: InputMaybe<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateCaiInstanceInput = {
  bubbleId?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  cogarchRole: Scalars['String']['input'];
  currentScope: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateOrganizationInput = {
  category: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  id: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateResponse = {
  __typename?: 'UpdateResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadDocumentsRequest = {
  cogarchEmbeddingId?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  s3Location: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  employeeDetails?: Maybe<EmployeeDetails>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id: Scalars['ID']['output'];
  isFirstLogin?: Maybe<Scalars['Boolean']['output']>;
  roles?: Maybe<Array<Permissions>>;
  stsUserId?: Maybe<Scalars['ID']['output']>;
  teams?: Maybe<Array<Maybe<Team>>>;
  userOrganizations?: Maybe<Array<UserOrganization>>;
};

export type UserDailyTokenUsage = {
  __typename?: 'UserDailyTokenUsage';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  tokensUsed: Scalars['Int']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  isActive: Scalars['Boolean']['output'];
  organization: Organization;
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserRegistrationInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  jwtToken: Scalars['String']['input'];
  language: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organisationId?: InputMaybe<Scalars['String']['input']>;
  personalTenantId: Scalars['String']['input'];
  stsOrganisationId?: InputMaybe<Scalars['String']['input']>;
  stsUserId: Scalars['String']['input'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  settingKey: Scalars['String']['output'];
  settingValue: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
};

export type UserSettingsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  settingKey: Scalars['String']['input'];
  settingValue: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type VideoTask = OnboardingTask & {
  __typename?: 'VideoTask';
  completionWeek?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  videoURL?: Maybe<Scalars['String']['output']>;
};

export type WorkExperience = {
  __typename?: 'WorkExperience';
  company?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type WorkingRole = {
  __typename?: 'WorkingRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modifiedBy?: Maybe<User>;
  name: Role;
};

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, stsUserId?: string | null, isFirstLogin?: boolean | null, email: string, userOrganizations?: Array<{ __typename?: 'UserOrganization', isActive: boolean, organization: { __typename?: 'Organization', id: string, name: string, industry?: string | null, type?: OrganizationType | null, logo?: string | null, stsOrganisationId?: string | null, category: OrganizationCategory, defaultLanguage?: string | null, ownerId?: string | null, usagePlan: OrganizationUsagePlan } }> | null, employeeDetails?: { __typename?: 'EmployeeDetails', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, bio?: string | null, employeeId?: string | null, avatar?: string | null, jobDescriptionText?: string | null, mobile?: string | null, role?: { __typename?: 'WorkingRole', id: string, name: Role } | null, jobDescription?: { __typename?: 'JobDescription', title?: string | null } | null } | null, roles?: Array<{ __typename?: 'Permissions', organizationId: string, workingRoles: Array<{ __typename?: 'WorkingRole', id: string, name: Role, description?: string | null }> }> | null } | null };

export type GetProgramsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  filter?: InputMaybe<ProgramFilter>;
}>;


export type GetProgramsQuery = { __typename?: 'Query', programs?: Array<{ __typename?: 'Program', id: string, title: string, taskStatus?: Array<number | null> | null, numberOfTasks?: number | null, endDate?: Date | string | null, effectiveDate?: Date | string | null, organizationId?: string | null, description?: string | null, categories?: Array<{ __typename?: 'Category', name: string, id: string } | null> | null, countingTaskStatus?: { __typename?: 'TaskStatusCount', toDo?: number | null, inProgress?: number | null, completed?: number | null } | null, createdBy?: { __typename?: 'User', employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null } | null } | null, programInstance?: { __typename?: 'ProgramInstance', id: string } | null } | null> | null };

export type GetProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programInstanceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetProgramQuery = { __typename?: 'Query', program?: { __typename?: 'Program', description?: string | null, numberOfTasks?: number | null, title: string, id: string, endDate?: Date | string | null, effectiveDate?: Date | string | null, organizationId?: string | null, allocatedProgramMembers?: Array<{ __typename?: 'AllocatedProgramMember', id: string, roles?: Array<{ __typename?: 'Permissions', organizationId: string, workingRoles: Array<{ __typename?: 'WorkingRole', id: string, name: Role, description?: string | null }> } | null> | null, employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, middleName?: string | null, lastName?: string | null, employeeId?: string | null, avatar?: string | null, jobDescriptionText?: string | null, mobile?: string | null, jobDescription?: { __typename?: 'JobDescription', title?: string | null } | null, role?: { __typename?: 'WorkingRole', id: string, name: Role } | null } | null } | null> | null, categories?: Array<{ __typename?: 'Category', name: string, id: string } | null> | null, programInstance?: { __typename?: 'ProgramInstance', id: string } | null, countingTaskStatus?: { __typename?: 'TaskStatusCount', toDo?: number | null, inProgress?: number | null, completed?: number | null } | null } | null };

export type GetProgramsInProgressTrackerQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  filter?: InputMaybe<ProgressTrackerFilter>;
}>;


export type GetProgramsInProgressTrackerQuery = { __typename?: 'Query', programsInProgressTracker?: Array<{ __typename?: 'Program', id: string, title: string, taskStatus?: Array<number | null> | null, numberOfTasks?: number | null, endDate?: Date | string | null, effectiveDate?: Date | string | null, organizationId?: string | null, description?: string | null, categories?: Array<{ __typename?: 'Category', id: string, name: string } | null> | null, createdBy?: { __typename?: 'User', employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null } | null } | null, countingTaskStatus?: { __typename?: 'TaskStatusCount', toDo?: number | null, inProgress?: number | null, completed?: number | null } | null } | null> | null };

export type GetEmployeesQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EmployeeFilter>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', employees?: Array<{ __typename?: 'User', email: string, stsUserId?: string | null, id: string, employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, employeeId?: string | null, avatar?: string | null } | null } | null> | null };

export type GetEmployeeQueryVariables = Exact<{
  employeeId: Scalars['ID']['input'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee?: { __typename?: 'User', email: string, id: string, stsUserId?: string | null, userOrganizations?: Array<{ __typename?: 'UserOrganization', organization: { __typename?: 'Organization', id: string, category: OrganizationCategory } }> | null, roles?: Array<{ __typename?: 'Permissions', organizationId: string, workingRoles: Array<{ __typename?: 'WorkingRole', id: string, name: Role }> }> | null, employeeDetails?: { __typename?: 'EmployeeDetails', bio?: string | null, phone?: string | null, jobDescriptionText?: string | null, mobile?: string | null, employeeId?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, resume?: string | null, avatar?: string | null, hiringDate?: Date | string | null, jobDescription?: { __typename?: 'JobDescription', title?: string | null } | null, location?: { __typename?: 'Location', country: string, id: string } | null, teams?: Array<{ __typename?: 'Team', id: string, name: string, organizationId: string } | null> | null } | null } | null };

export type GetAllTasksAssignedToUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetAllTasksAssignedToUserQuery = { __typename?: 'Query', tasksAssignedToUser?: Array<{ __typename?: 'TaskWithAssignee', title?: string | null, description?: string | null, type?: TaskType | null, id: string, assignee?: { __typename?: 'TaskAssignee', status?: TaskStatus | null, endDate?: Date | string | null, employeeDetails?: { __typename?: 'EmployeeDetails', employeeId?: string | null, avatar?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null } | null } | null> | null };

export type GetWorkingRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkingRolesQuery = { __typename?: 'Query', workingRoles?: Array<{ __typename?: 'WorkingRole', id: string, name: Role } | null> | null };

export type UpdateUserRoleMutationVariables = Exact<{
  employeeId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type GetCaiInstanceQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetCaiInstanceQuery = { __typename?: 'Query', caiInstance?: { __typename?: 'CaiInstance', id: string, chatId: string, cogarchRole: string, currentScope: string, previousBubbleId?: string | null, user: { __typename?: 'User', id: string, email: string } } | null };

export type UpdateCaiInstanceMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateCaiInstanceInput>;
}>;


export type UpdateCaiInstanceMutation = { __typename?: 'Mutation', updateCaiInstance?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type GetTaskQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  taskInstanceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTaskQuery = { __typename?: 'Query', task?: { __typename: 'Task', id: string, title?: string | null, attachmentIds?: Array<string | null> | null, cogarchCourseId?: string | null, cogarchTaskId?: string | null, coachCategory?: CoachCategory | null, organizationId?: string | null, isInActive?: boolean | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, isReset?: boolean | null, type?: TaskType | null, description?: string | null, activities?: Array<{ __typename: 'CaiSessionActivity', sessionId: string, id: string, taskActivityId: string } | { __typename: 'MentorActivity', id: string, taskActivityId: string, instances?: Array<{ __typename?: 'MentorInstance', id: string, chatId: string, cogarchRole: string, completed: boolean, currentQuiz: number, mentorActivityId: string, taskInstanceId: string, quizzes?: Array<{ __typename?: 'Quiz', answers?: Array<string | null> | null, id: string, mentorInstanceId: string, passed?: boolean | null, noOfAttempts: number, position: number, providedAnswer?: string | null, correctAnswer?: string | null, question: string } | null> | null } | null> | null, questions?: Array<{ __typename?: 'MentorQuestions', id: string, correct_answer: string, incorrect_answers?: Array<string | null> | null, position: number, question: string, quiz_id: string } | null> | null } | { __typename: 'PresentationActivity', slides?: Array<string | null> | null, dialogue?: Array<string | null> | null, id: string, taskActivityId: string, instances?: Array<{ __typename?: 'PresentationInstance', id: string, chatId: string, cogarchRole: string, currentSlide: number, completed: boolean, presentationActivityId: string, taskInstanceId: string } | null> | null } | null> | null, categories?: Array<{ __typename?: 'Category', name: string, id: string } | null> | null } | { __typename: 'TaskWithAssignee', taskInstanceId?: string | null, title?: string | null, attachmentIds?: Array<string | null> | null, cogarchCourseId?: string | null, cogarchTaskId?: string | null, isInActive?: boolean | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, isReset?: boolean | null, assignee?: { __typename?: 'TaskAssignee', email: string, status?: TaskStatus | null, employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, middleName?: string | null, lastName?: string | null, jobDescriptionText?: string | null, mobile?: string | null, avatar?: string | null, jobDescription?: { __typename?: 'JobDescription', title?: string | null } | null } | null } | null, activities?: Array<{ __typename: 'CaiSessionActivity', sessionId: string, id: string, taskActivityId: string } | { __typename: 'MentorActivity', id: string, taskActivityId: string, instances?: Array<{ __typename?: 'MentorInstance', id: string, chatId: string, cogarchRole: string, completed: boolean, currentQuiz: number, taskInstanceId: string, mentorActivityId: string, quizzes?: Array<{ __typename?: 'Quiz', answers?: Array<string | null> | null, id: string, mentorInstanceId: string, passed?: boolean | null, noOfAttempts: number, position: number, providedAnswer?: string | null, question: string, correctAnswer?: string | null } | null> | null } | null> | null, questions?: Array<{ __typename?: 'MentorQuestions', id: string, correct_answer: string, incorrect_answers?: Array<string | null> | null, position: number, question: string, quiz_id: string } | null> | null } | { __typename: 'PresentationActivity', slides?: Array<string | null> | null, dialogue?: Array<string | null> | null, id: string, taskActivityId: string, instances?: Array<{ __typename?: 'PresentationInstance', chatId: string, cogarchRole: string, currentSlide: number, completed: boolean, taskInstanceId: string, presentationActivityId: string, id: string } | null> | null } | null> | null } | null };

export type GetTasksByProgramQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  filter?: InputMaybe<TaskProgramFilter>;
  organizationId: Scalars['ID']['input'];
}>;


export type GetTasksByProgramQuery = { __typename?: 'Query', tasksByProgram?: { __typename?: 'TaskProgram', allTasks?: Array<{ __typename?: 'Task', title?: string | null, description?: string | null, id: string, isInActive?: boolean | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, type?: TaskType | null, categories?: Array<{ __typename?: 'Category', name: string } | null> | null } | null> | null, selectedTasks?: Array<{ __typename?: 'Task', title?: string | null, description?: string | null, id: string, isInActive?: boolean | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, type?: TaskType | null, categories?: Array<{ __typename?: 'Category', name: string } | null> | null } | null> | null, includedTasks?: Array<{ __typename?: 'Task', title?: string | null, description?: string | null, id: string, isInActive?: boolean | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, type?: TaskType | null, categories?: Array<{ __typename?: 'Category', name: string } | null> | null } | null> | null } | null };

export type GetTaskCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaskCategoriesQuery = { __typename?: 'Query', taskCategories?: Array<{ __typename?: 'Category', id: string, name: string } | null> | null };

export type AnswerMentorInstanceQuizMutationVariables = Exact<{
  input: MentorInstanceQuizAnswer;
}>;


export type AnswerMentorInstanceQuizMutation = { __typename?: 'Mutation', answerMentorInstanceQuiz?: { __typename?: 'UpdateResponse', data?: any | null } | null };

export type UpdateCurrentSlideNumberMutationVariables = Exact<{
  presentationInstanceId: Scalars['ID']['input'];
  presentationActivityId: Scalars['ID']['input'];
  slideNumber: Scalars['Int']['input'];
}>;


export type UpdateCurrentSlideNumberMutation = { __typename?: 'Mutation', updateCurrentSlideNumber?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type CompleteTaskActivityMutationVariables = Exact<{
  activityId?: InputMaybe<Scalars['ID']['input']>;
  activityInstanceId?: InputMaybe<Scalars['ID']['input']>;
  activityType: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteTaskActivityMutation = { __typename?: 'Mutation', completeTaskActivity?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type RetakeTaskMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  taskInstanceId: Scalars['ID']['input'];
}>;


export type RetakeTaskMutation = { __typename?: 'Mutation', retakeTask?: { __typename?: 'UpdateResponse', data?: any | null, success: boolean } | null };

export type GetTasksQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TaskFilter>;
}>;


export type GetTasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskPagination', totalItems?: number | null, tasks?: Array<{ __typename?: 'Task', updatedAt?: Date | string | null, id: string, title?: string | null, attachmentIds?: Array<string | null> | null, description?: string | null, isInActive?: boolean | null, createdAt?: Date | string | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, type?: TaskType | null, s3Bucket?: string | null, s3Location?: string | null, s3Key?: string | null, createdBy?: { __typename?: 'User', employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null } | null } | null, categories?: Array<{ __typename?: 'Category', name: string } | null> | null } | null> | null } | null };

export type GetUserTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTeamsQuery = { __typename?: 'Query', userTeams?: Array<{ __typename?: 'Team', id: string, name: string } | null> | null };

export type GetTeamsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<TeamFilter>;
}>;


export type GetTeamsQuery = { __typename?: 'Query', teams?: Array<{ __typename?: 'Team', id: string, name: string, owner?: { __typename?: 'User', employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, middleName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, members?: Array<{ __typename?: 'TeamUserDetails', memberId: string, email: string, isManager: boolean, employeeDetails?: { __typename?: 'EmployeeDetails', avatar?: string | null, employeeId?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null } | null> | null } | null> | null };

export type GetQuizStatisticQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  activityId: Scalars['ID']['input'];
  activityInstanceId: Scalars['ID']['input'];
  taskInstanceId: Scalars['ID']['input'];
}>;


export type GetQuizStatisticQuery = { __typename?: 'Query', quizStatistic?: { __typename?: 'QuizStatistic', data?: Array<number | null> | null, totalNumberOfQuizzes?: number | null } | null };

export type AssignProgramMutationVariables = Exact<{
  input?: InputMaybe<AssignProgramInput>;
}>;


export type AssignProgramMutation = { __typename?: 'Mutation', assignProgram?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type AssignTaskMutationVariables = Exact<{
  input?: InputMaybe<AssignTaskInput>;
}>;


export type AssignTaskMutation = { __typename?: 'Mutation', assignTask?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type UnassignProgramMutationVariables = Exact<{
  input?: InputMaybe<UnassignProgramInput>;
}>;


export type UnassignProgramMutation = { __typename?: 'Mutation', unassignProgram?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type GetProgramCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramCategoriesQuery = { __typename?: 'Query', programCategories?: Array<{ __typename?: 'Category', id: string, name: string } | null> | null };

export type SaveProgramMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  input?: InputMaybe<SaveProgramInput>;
}>;


export type SaveProgramMutation = { __typename?: 'Mutation', saveProgram?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type ResetUserToDemoStateMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ResetUserToDemoStateMutation = { __typename?: 'Mutation', resetUserToDemoState?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type UpdateProgramTaskStatusMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
}>;


export type UpdateProgramTaskStatusMutation = { __typename?: 'Mutation', updateProgramTaskStatus?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type PublishProgramMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type PublishProgramMutation = { __typename?: 'Mutation', publishProgram?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type GetAssignedTasksByProgramQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type GetAssignedTasksByProgramQuery = { __typename?: 'Query', assignedTasksByProgram?: Array<{ __typename?: 'TaskWithAssignee', isInActive?: boolean | null, title?: string | null, description?: string | null, id: string, taskInstanceId?: string | null, lastSequence?: number | null, isTaskAssigned?: boolean | null, type?: TaskType | null, assignee?: { __typename?: 'TaskAssignee', status?: TaskStatus | null, endDate?: Date | string | null, employeeDetails?: { __typename?: 'EmployeeDetails', employeeId?: string | null, avatar?: string | null, firstName?: string | null, middleName?: string | null, lastName?: string | null } | null } | null, categories?: Array<{ __typename?: 'Category', name: string } | null> | null } | null> | null };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: string, name: string, category: OrganizationCategory, ownerId?: string | null } | null> | null };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, industry?: string | null, type?: OrganizationType | null, logo?: string | null, stsOrganisationId?: string | null, category: OrganizationCategory, defaultLanguage?: string | null, ownerId?: string | null, usagePlan: OrganizationUsagePlan, memberCount: number, workspaceCost: number, documentCount: number, lastResetDate?: Date | string | null, userOrganizations?: Array<{ __typename?: 'UserOrganization', userId: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string } } | null> | null, subscriptionDetails?: { __typename?: 'SubscriptionDetails', id: string, status: string, nextBillingDate?: number | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, nextCycleAmount?: number | null, currentCycleAmount?: number | null, reserveTokens: number, customerId?: string | null, lastInvoiceUrl?: string | null, dateToBeDowngraded?: number | null, unitPrice: number, subscribedSeats: number } | null, stripeUpgradePrompt?: { __typename?: 'StripeUpgradePrompt', id: string, gracePeriodEnd?: Date | string | null, organizationId: string, reason?: string | null, createdAt?: Date | string | null, updatedAt?: Date | string | null } | null } | null };

export type GetOrganizationByStsIdQueryVariables = Exact<{
  stsOrganisationId: Scalars['ID']['input'];
}>;


export type GetOrganizationByStsIdQuery = { __typename?: 'Query', organizationByStsId?: { __typename?: 'Organization', id: string, name: string, industry?: string | null, type?: OrganizationType | null, logo?: string | null, stsOrganisationId?: string | null, category: OrganizationCategory, defaultLanguage?: string | null, ownerId?: string | null, usagePlan: OrganizationUsagePlan, memberCount: number, workspaceCost: number, documentCount: number, lastResetDate?: Date | string | null, userOrganizations?: Array<{ __typename?: 'UserOrganization', userId: string, isActive: boolean, user: { __typename?: 'User', id: string, email: string } } | null> | null, subscriptionDetails?: { __typename?: 'SubscriptionDetails', id: string, status: string, nextBillingDate?: number | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, nextCycleAmount?: number | null, currentCycleAmount?: number | null, reserveTokens: number, customerId?: string | null, lastInvoiceUrl?: string | null, dateToBeDowngraded?: number | null, unitPrice: number, subscribedSeats: number } | null, stripeUpgradePrompt?: { __typename?: 'StripeUpgradePrompt', id: string, gracePeriodEnd?: Date | string | null, organizationId: string, reason?: string | null, createdAt?: Date | string | null, updatedAt?: Date | string | null } | null } | null };

export type GetInvoicesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, organizationId: string, date: Date | string, total: number, originalAmount?: number | null, discount?: number | null, url: string, description?: string | null }> };

export type GetLatestOrganizationInvoiceQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetLatestOrganizationInvoiceQuery = { __typename?: 'Query', latestOrganizationInvoice?: { __typename?: 'Invoice', id: string, organizationId: string, date: Date | string, total: number, originalAmount?: number | null, discount?: number | null, url: string, description?: string | null } | null };

export type GetUserDailyTokenUsageQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetUserDailyTokenUsageQuery = { __typename?: 'Query', userDailyTokenUsage?: { __typename?: 'UserDailyTokenUsage', id: string, userId: string, organizationId: string, date: Date | string, tokensUsed: number } | null };

export type GetTokenPackCostQueryVariables = Exact<{
  tokenAmount: Scalars['Int']['input'];
}>;


export type GetTokenPackCostQuery = { __typename?: 'Query', tokenPackCost: { __typename?: 'TokenPackCost', tokenAmount: number, totalCost: number, lineItems: Array<{ __typename?: 'TokenPackLineItem', productName: string, tokenAmount: number, cost: number, quantity: number }> } };

export type GetWorkspaceCostQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  memberCount: Scalars['Int']['input'];
  usagePlan?: InputMaybe<OrganizationUsagePlan>;
}>;


export type GetWorkspaceCostQuery = { __typename?: 'Query', workspaceCost: number };

export type PurchaseTokenPackMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  tokenAmount: Scalars['Int']['input'];
}>;


export type PurchaseTokenPackMutation = { __typename?: 'Mutation', purchaseTokenPack: { __typename?: 'PurchaseTokenPackResponse', sessionId: string, sessionUrl: string } };

export type CreateSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  planType?: InputMaybe<OrganizationUsagePlan>;
  desiredSeats: Scalars['Int']['input'];
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'CreateCheckoutSessionResponse', sessionId: string, sessionUrl: string } };

export type PurchaseAdditionalSeatsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  desiredSeats: Scalars['Int']['input'];
}>;


export type PurchaseAdditionalSeatsMutation = { __typename?: 'Mutation', purchaseAdditionalSeats: { __typename?: 'CreateCheckoutSessionResponse', sessionId: string, sessionUrl: string } };

export type ScheduleDowngradeSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  targetPlan: OrganizationUsagePlan;
}>;


export type ScheduleDowngradeSubscriptionMutation = { __typename?: 'Mutation', scheduleDowngradeSubscription: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'Query', locations?: Array<{ __typename?: 'Location', id: string, zipCode: string, region?: string | null, state?: string | null, country: string, zone?: string | null, global?: string | null } | null> | null };

export type SaveUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  input?: InputMaybe<SaveUserInput>;
}>;


export type SaveUserMutation = { __typename?: 'Mutation', saveUser?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type AddUserToOrganisationMutationVariables = Exact<{
  stsUserId?: InputMaybe<Scalars['ID']['input']>;
  stsOrganisationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddUserToOrganisationMutation = { __typename?: 'Mutation', addUserToOrganisation?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type SaveCompanyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  input?: InputMaybe<SaveCompanyInput>;
}>;


export type SaveCompanyMutation = { __typename?: 'Mutation', saveCompany?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type UpdatePreviousBubbleIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  caiInstanceId: Scalars['ID']['input'];
  bubbleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePreviousBubbleIdMutation = { __typename?: 'Mutation', updatePreviousBubbleId?: { __typename?: 'UpdateResponse', success: boolean, data?: any | null, message?: string | null } | null };

export type GetAnnouncementsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetAnnouncementsQuery = { __typename?: 'Query', announcements?: { __typename?: 'Announcements', id: string, organizationId: string, icon: string, title: string, body: string } | null };

export type GetDocumentsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetDocumentsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'Documents', id: string, organizationId: string, title: string, updatedAt: Date | string, s3Location: string, s3Bucket: string, s3Key: string, cogarchEmbeddingId?: string | null, createdAt: Date | string, createdBy: { __typename?: 'User', employeeDetails?: { __typename?: 'EmployeeDetails', firstName?: string | null, lastName?: string | null, middleName?: string | null, avatar?: string | null } | null } } | null> | null };

export type GetTreeDocumentsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetTreeDocumentsQuery = { __typename?: 'Query', treeDocuments?: Array<any | null> | null };

export type GetStarterProgramsQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStarterProgramsQuery = { __typename?: 'Query', starterPrograms?: { __typename?: 'StarterProgramPagination', totalItems?: number | null, starterPrograms?: Array<{ __typename?: 'StarterProgram', id: string, organizationType: OrganizationCategory, language: string, programIds?: Array<string> | null, updatedAt?: Date | string | null, createdAt?: Date | string | null } | null> | null } | null };

export type GetPaginatedOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFilter>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPaginatedOrganizationsQuery = { __typename?: 'Query', paginatedOrganizations?: { __typename?: 'OrganizationPagination', totalItems?: number | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string, industry?: string | null, type?: OrganizationType | null, logo?: string | null, stsOrganisationId?: string | null, category: OrganizationCategory, defaultLanguage?: string | null, markDeleted?: boolean | null, usagePlan: OrganizationUsagePlan } | null> | null } | null };

export type UploadDocumentsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  documents?: InputMaybe<Array<InputMaybe<UploadDocumentsRequest>> | InputMaybe<UploadDocumentsRequest>>;
}>;


export type UploadDocumentsMutation = { __typename?: 'Mutation', uploadDocuments?: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } | null };

export type DeleteDocumentMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument?: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } | null };

export type UpdateDocumentMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  s3Location: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  s3Bucket: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument?: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } | null };

export type UpdateDocumentFilePathMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
}>;


export type UpdateDocumentFilePathMutation = { __typename?: 'Mutation', updateDocumentFilePath?: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } | null };

export type RegisterUserMutationVariables = Exact<{
  input: UserRegistrationInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', registerUser?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type SaveTeamMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  input?: InputMaybe<SaveTeamInput>;
}>;


export type SaveTeamMutation = { __typename?: 'Mutation', saveTeam?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type DeleteTeamMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type AddUserToTeamMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userIdToAdd: Scalars['ID']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddUserToTeamMutation = { __typename?: 'Mutation', addUserToTeam?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type RemoveUserFromTeamMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  userIdToRemove: Scalars['ID']['input'];
}>;


export type RemoveUserFromTeamMutation = { __typename?: 'Mutation', removeUserFromTeam?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type PromoteOrDemoteUserInTeamMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  userIdToUpdate: Scalars['ID']['input'];
}>;


export type PromoteOrDemoteUserInTeamMutation = { __typename?: 'Mutation', promoteOrDemoteUserInTeam?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type TransferTeamOwnerShipMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  newOwnerId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
}>;


export type TransferTeamOwnerShipMutation = { __typename?: 'Mutation', transferTeamOwnership?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userIdToDelete: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type RemoveUserFromOrganisationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
}>;


export type RemoveUserFromOrganisationMutation = { __typename?: 'Mutation', removeUserFromOrganisation?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type DeleteProgramMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
}>;


export type DeleteProgramMutation = { __typename?: 'Mutation', deleteProgram?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type SaveTaskMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  input?: InputMaybe<SaveTaskInput>;
}>;


export type SaveTaskMutation = { __typename?: 'Mutation', saveTask?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type AddTaskClipboardMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<AddTaskClipboardInput>> | InputMaybe<AddTaskClipboardInput>>;
}>;


export type AddTaskClipboardMutation = { __typename?: 'Mutation', addTaskClipboard?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type SaveTaskDetailsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  stsOrganisationId: Scalars['ID']['input'];
  input?: InputMaybe<SaveTaskDetailsInput>;
}>;


export type SaveTaskDetailsMutation = { __typename?: 'Mutation', saveTaskDetails?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type UpdateTaskInstanceResetFlagMutationVariables = Exact<{
  taskInstanceId: Scalars['ID']['input'];
}>;


export type UpdateTaskInstanceResetFlagMutation = { __typename?: 'Mutation', updateTaskInstanceResetFlag?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type DeleteTaskMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
}>;


export type DeleteTaskMutation = { __typename?: 'Mutation', deleteTask?: { __typename?: 'UpdateResponse', success: boolean } | null };

export type ValidateIntegrationUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ValidateIntegrationUserMutation = { __typename?: 'Mutation', validateIntegrationUser?: { __typename?: 'IntegrationUserValidationResponse', isExist: boolean, message?: string | null } | null };

export type UserSettingsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserSettingsQuery = { __typename?: 'Query', userSettings?: Array<{ __typename?: 'UserSettings', id: string, createdAt?: Date | string | null, organizationId: string, settingKey: string, settingValue: string, updatedAt?: Date | string | null, userId: string } | null> | null };

export type UpsertUserSettingMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  settingKey: Scalars['String']['input'];
  settingValue: Scalars['String']['input'];
  userSettingId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
}>;


export type UpsertUserSettingMutation = { __typename?: 'Mutation', upsertUserSetting?: { __typename?: 'UpdateResponse', message?: string | null, success: boolean } | null };

export type UpsertUserSettingsMutationVariables = Exact<{
  settings: Array<InputMaybe<UserSettingsInput>> | InputMaybe<UserSettingsInput>;
}>;


export type UpsertUserSettingsMutation = { __typename?: 'Mutation', upsertUserSettings?: { __typename?: 'UpdateResponse', message?: string | null, success: boolean } | null };

export type UserOrganizationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserOrganizationsQuery = { __typename?: 'Query', userOrganizations?: Array<{ __typename?: 'UserOrganization', isActive: boolean, organization: { __typename?: 'Organization', id: string, name: string, stsOrganisationId?: string | null, logo?: string | null, category: OrganizationCategory, defaultLanguage?: string | null } } | null> | null };

export type GetCategoriesQueryVariables = Exact<{
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CategoryFilter>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryPagination', totalItems?: number | null, categories?: Array<{ __typename?: 'Category', id: string, name: string, type: CategoryType } | null> | null } | null };

export type SaveCategoryMutationVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  input?: InputMaybe<SaveCategoryInput>;
}>;


export type SaveCategoryMutation = { __typename?: 'Mutation', saveCategory?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type DeleteCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type SaveStarterProgramMutationVariables = Exact<{
  input?: InputMaybe<SaveStarterProgramInput>;
}>;


export type SaveStarterProgramMutation = { __typename?: 'Mutation', saveStarterProgram?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type DeleteStarterProgramMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStarterProgramMutation = { __typename?: 'Mutation', deleteStarterProgram?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type ChangeStatusOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ChangeStatusOrganizationMutation = { __typename?: 'Mutation', changeStatusOrganization?: { __typename?: 'UpdateResponse', data?: any | null, message?: string | null, success: boolean } | null };

export type GeneratePresignedPutUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
  folder: Scalars['String']['input'];
}>;


export type GeneratePresignedPutUrlMutation = { __typename?: 'Mutation', generatePresignedPutUrl: { __typename?: 'PresignedUrlResponse', url: string, key: string, location?: string | null, bucket: string } };

export type GeneratePresignedDeleteUrlMutationVariables = Exact<{
  existingKey: Scalars['String']['input'];
}>;


export type GeneratePresignedDeleteUrlMutation = { __typename?: 'Mutation', generatePresignedDeleteUrl: { __typename?: 'PresignedUrlResponse', url: string, key: string, bucket: string } };

export type GeneratePresignedGetUrlMutationVariables = Exact<{
  existingKey: Scalars['String']['input'];
}>;


export type GeneratePresignedGetUrlMutation = { __typename?: 'Mutation', generatePresignedGetUrl: { __typename?: 'PresignedUrlResponse', url: string, key: string, bucket: string } };

export type ReorderIncludedTasksMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  taskOrders: Array<TaskOrderInput> | TaskOrderInput;
}>;


export type ReorderIncludedTasksMutation = { __typename?: 'Mutation', reorderIncludedTasks: { __typename?: 'UpdateResponse', success: boolean, message?: string | null } };


export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    stsUserId
    isFirstLogin
    email
    userOrganizations {
      organization {
        id
        name
        industry
        type
        logo
        stsOrganisationId
        category
        defaultLanguage
        ownerId
        usagePlan
      }
      isActive
    }
    employeeDetails {
      id
      firstName
      middleName
      lastName
      role {
        id
        name
      }
      bio
      employeeId
      avatar
      jobDescription {
        title
      }
      jobDescriptionText
      mobile
    }
    roles {
      organizationId
      workingRoles {
        id
        name
        description
      }
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetProgramsDocument = gql`
    query GetPrograms($userId: ID!, $roleId: ID!, $filter: ProgramFilter) {
  programs(userId: $userId, roleId: $roleId, filter: $filter) {
    id
    title
    taskStatus
    numberOfTasks
    endDate
    effectiveDate
    organizationId
    categories {
      name
      id
    }
    description
    countingTaskStatus {
      toDo
      inProgress
      completed
    }
    createdBy {
      employeeDetails {
        firstName
        lastName
        middleName
      }
    }
    programInstance {
      id
    }
  }
}
    `;

/**
 * __useGetProgramsQuery__
 *
 * To run a query within a React component, call `useGetProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProgramsQuery(baseOptions: Apollo.QueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables> & ({ variables: GetProgramsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
      }
export function useGetProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export function useGetProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgramsQuery, GetProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramsQuery, GetProgramsQueryVariables>(GetProgramsDocument, options);
        }
export type GetProgramsQueryHookResult = ReturnType<typeof useGetProgramsQuery>;
export type GetProgramsLazyQueryHookResult = ReturnType<typeof useGetProgramsLazyQuery>;
export type GetProgramsSuspenseQueryHookResult = ReturnType<typeof useGetProgramsSuspenseQuery>;
export type GetProgramsQueryResult = Apollo.QueryResult<GetProgramsQuery, GetProgramsQueryVariables>;
export const GetProgramDocument = gql`
    query GetProgram($programId: ID!, $roleId: ID!, $programInstanceId: ID) {
  program(
    programId: $programId
    roleId: $roleId
    programInstanceId: $programInstanceId
  ) {
    allocatedProgramMembers {
      id
      roles {
        organizationId
        workingRoles {
          id
          name
          description
        }
      }
      employeeDetails {
        firstName
        middleName
        lastName
        jobDescription {
          title
        }
        role {
          id
          name
        }
        employeeId
        avatar
        jobDescriptionText
        mobile
      }
    }
    categories {
      name
      id
    }
    description
    numberOfTasks
    programInstance {
      id
    }
    title
    id
    endDate
    effectiveDate
    organizationId
    countingTaskStatus {
      toDo
      inProgress
      completed
    }
  }
}
    `;

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      roleId: // value for 'roleId'
 *      programInstanceId: // value for 'programInstanceId'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: Apollo.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables> & ({ variables: GetProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export function useGetProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramSuspenseQueryHookResult = ReturnType<typeof useGetProgramSuspenseQuery>;
export type GetProgramQueryResult = Apollo.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const GetProgramsInProgressTrackerDocument = gql`
    query GetProgramsInProgressTracker($userId: ID!, $roleId: ID!, $organizationId: ID!, $filter: ProgressTrackerFilter) {
  programsInProgressTracker(
    userId: $userId
    roleId: $roleId
    organizationId: $organizationId
    filter: $filter
  ) {
    id
    title
    taskStatus
    numberOfTasks
    endDate
    effectiveDate
    organizationId
    categories {
      id
      name
    }
    createdBy {
      employeeDetails {
        firstName
        lastName
        middleName
      }
    }
    description
    countingTaskStatus {
      toDo
      inProgress
      completed
    }
  }
}
    `;

/**
 * __useGetProgramsInProgressTrackerQuery__
 *
 * To run a query within a React component, call `useGetProgramsInProgressTrackerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramsInProgressTrackerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramsInProgressTrackerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProgramsInProgressTrackerQuery(baseOptions: Apollo.QueryHookOptions<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables> & ({ variables: GetProgramsInProgressTrackerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>(GetProgramsInProgressTrackerDocument, options);
      }
export function useGetProgramsInProgressTrackerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>(GetProgramsInProgressTrackerDocument, options);
        }
export function useGetProgramsInProgressTrackerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>(GetProgramsInProgressTrackerDocument, options);
        }
export type GetProgramsInProgressTrackerQueryHookResult = ReturnType<typeof useGetProgramsInProgressTrackerQuery>;
export type GetProgramsInProgressTrackerLazyQueryHookResult = ReturnType<typeof useGetProgramsInProgressTrackerLazyQuery>;
export type GetProgramsInProgressTrackerSuspenseQueryHookResult = ReturnType<typeof useGetProgramsInProgressTrackerSuspenseQuery>;
export type GetProgramsInProgressTrackerQueryResult = Apollo.QueryResult<GetProgramsInProgressTrackerQuery, GetProgramsInProgressTrackerQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($roleId: ID!, $organizationId: ID, $searchTerm: String, $filter: EmployeeFilter) {
  employees(
    roleId: $roleId
    organizationId: $organizationId
    searchTerm: $searchTerm
    filter: $filter
  ) {
    employeeDetails {
      firstName
      lastName
      middleName
      employeeId
      avatar
    }
    email
    stsUserId
    id
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      searchTerm: // value for 'searchTerm'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables> & ({ variables: GetEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export function useGetEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesSuspenseQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetEmployeeDocument = gql`
    query GetEmployee($employeeId: ID!) {
  employee(employeeId: $employeeId) {
    email
    id
    stsUserId
    userOrganizations {
      organization {
        id
        category
      }
    }
    roles {
      organizationId
      workingRoles {
        id
        name
      }
    }
    employeeDetails {
      bio
      phone
      jobDescription {
        title
      }
      jobDescriptionText
      mobile
      employeeId
      firstName
      lastName
      middleName
      resume
      location {
        country
        id
      }
      avatar
      teams {
        id
        name
        organizationId
      }
      hiringDate
    }
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables> & ({ variables: GetEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeSuspenseQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetAllTasksAssignedToUserDocument = gql`
    query GetAllTasksAssignedToUser($userId: ID!) {
  tasksAssignedToUser(userId: $userId) {
    assignee {
      status
      employeeDetails {
        employeeId
        avatar
        firstName
        middleName
        lastName
      }
      endDate
    }
    title
    description
    type
    id
  }
}
    `;

/**
 * __useGetAllTasksAssignedToUserQuery__
 *
 * To run a query within a React component, call `useGetAllTasksAssignedToUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTasksAssignedToUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTasksAssignedToUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAllTasksAssignedToUserQuery(baseOptions: Apollo.QueryHookOptions<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables> & ({ variables: GetAllTasksAssignedToUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>(GetAllTasksAssignedToUserDocument, options);
      }
export function useGetAllTasksAssignedToUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>(GetAllTasksAssignedToUserDocument, options);
        }
export function useGetAllTasksAssignedToUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>(GetAllTasksAssignedToUserDocument, options);
        }
export type GetAllTasksAssignedToUserQueryHookResult = ReturnType<typeof useGetAllTasksAssignedToUserQuery>;
export type GetAllTasksAssignedToUserLazyQueryHookResult = ReturnType<typeof useGetAllTasksAssignedToUserLazyQuery>;
export type GetAllTasksAssignedToUserSuspenseQueryHookResult = ReturnType<typeof useGetAllTasksAssignedToUserSuspenseQuery>;
export type GetAllTasksAssignedToUserQueryResult = Apollo.QueryResult<GetAllTasksAssignedToUserQuery, GetAllTasksAssignedToUserQueryVariables>;
export const GetWorkingRolesDocument = gql`
    query GetWorkingRoles {
  workingRoles {
    id
    name
  }
}
    `;

/**
 * __useGetWorkingRolesQuery__
 *
 * To run a query within a React component, call `useGetWorkingRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkingRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkingRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkingRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>(GetWorkingRolesDocument, options);
      }
export function useGetWorkingRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>(GetWorkingRolesDocument, options);
        }
export function useGetWorkingRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>(GetWorkingRolesDocument, options);
        }
export type GetWorkingRolesQueryHookResult = ReturnType<typeof useGetWorkingRolesQuery>;
export type GetWorkingRolesLazyQueryHookResult = ReturnType<typeof useGetWorkingRolesLazyQuery>;
export type GetWorkingRolesSuspenseQueryHookResult = ReturnType<typeof useGetWorkingRolesSuspenseQuery>;
export type GetWorkingRolesQueryResult = Apollo.QueryResult<GetWorkingRolesQuery, GetWorkingRolesQueryVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($employeeId: ID!, $roleId: ID!) {
  updateUserRole(employeeId: $employeeId, roleId: $roleId) {
    success
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const GetCaiInstanceDocument = gql`
    query GetCaiInstance($userId: ID!) {
  caiInstance(userId: $userId) {
    id
    chatId
    cogarchRole
    currentScope
    previousBubbleId
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useGetCaiInstanceQuery__
 *
 * To run a query within a React component, call `useGetCaiInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaiInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaiInstanceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCaiInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetCaiInstanceQuery, GetCaiInstanceQueryVariables> & ({ variables: GetCaiInstanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>(GetCaiInstanceDocument, options);
      }
export function useGetCaiInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>(GetCaiInstanceDocument, options);
        }
export function useGetCaiInstanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>(GetCaiInstanceDocument, options);
        }
export type GetCaiInstanceQueryHookResult = ReturnType<typeof useGetCaiInstanceQuery>;
export type GetCaiInstanceLazyQueryHookResult = ReturnType<typeof useGetCaiInstanceLazyQuery>;
export type GetCaiInstanceSuspenseQueryHookResult = ReturnType<typeof useGetCaiInstanceSuspenseQuery>;
export type GetCaiInstanceQueryResult = Apollo.QueryResult<GetCaiInstanceQuery, GetCaiInstanceQueryVariables>;
export const UpdateCaiInstanceDocument = gql`
    mutation UpdateCaiInstance($userId: ID!, $input: UpdateCaiInstanceInput) {
  updateCaiInstance(userId: $userId, input: $input) {
    data
    message
    success
  }
}
    `;
export type UpdateCaiInstanceMutationFn = Apollo.MutationFunction<UpdateCaiInstanceMutation, UpdateCaiInstanceMutationVariables>;

/**
 * __useUpdateCaiInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateCaiInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaiInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaiInstanceMutation, { data, loading, error }] = useUpdateCaiInstanceMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaiInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaiInstanceMutation, UpdateCaiInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaiInstanceMutation, UpdateCaiInstanceMutationVariables>(UpdateCaiInstanceDocument, options);
      }
export type UpdateCaiInstanceMutationHookResult = ReturnType<typeof useUpdateCaiInstanceMutation>;
export type UpdateCaiInstanceMutationResult = Apollo.MutationResult<UpdateCaiInstanceMutation>;
export type UpdateCaiInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateCaiInstanceMutation, UpdateCaiInstanceMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($userId: ID!, $roleId: ID!, $taskId: ID!, $organizationId: ID!, $stsOrganisationId: ID!, $taskInstanceId: ID) {
  task(
    userId: $userId
    roleId: $roleId
    taskId: $taskId
    organizationId: $organizationId
    stsOrganisationId: $stsOrganisationId
    taskInstanceId: $taskInstanceId
  ) {
    ... on Task {
      __typename
      id
      title
      attachmentIds
      cogarchCourseId
      cogarchTaskId
      coachCategory
      organizationId
      activities {
        id
        taskActivityId
        ... on MentorActivity {
          __typename
          instances {
            id
            chatId
            cogarchRole
            completed
            currentQuiz
            quizzes {
              answers
              id
              mentorInstanceId
              passed
              noOfAttempts
              position
              providedAnswer
              correctAnswer
              question
            }
            mentorActivityId
            taskInstanceId
          }
          questions {
            id
            correct_answer
            incorrect_answers
            position
            question
            quiz_id
          }
        }
        ... on PresentationActivity {
          __typename
          slides
          dialogue
          instances {
            id
            chatId
            cogarchRole
            currentSlide
            completed
            presentationActivityId
            taskInstanceId
          }
        }
        ... on CaiSessionActivity {
          __typename
          sessionId
        }
      }
      isInActive
      lastSequence
      isTaskAssigned
      isReset
      type
      description
      categories {
        name
        id
      }
    }
    ... on TaskWithAssignee {
      __typename
      taskInstanceId
      title
      attachmentIds
      cogarchCourseId
      cogarchTaskId
      assignee {
        email
        status
        employeeDetails {
          firstName
          middleName
          lastName
          jobDescription {
            title
          }
          jobDescriptionText
          mobile
          avatar
        }
      }
      activities {
        id
        taskActivityId
        ... on MentorActivity {
          __typename
          instances {
            id
            chatId
            cogarchRole
            completed
            currentQuiz
            quizzes {
              answers
              id
              mentorInstanceId
              passed
              noOfAttempts
              position
              providedAnswer
              question
              correctAnswer
            }
            taskInstanceId
            mentorActivityId
          }
          questions {
            id
            correct_answer
            incorrect_answers
            position
            question
            quiz_id
          }
        }
        ... on PresentationActivity {
          __typename
          slides
          dialogue
          instances {
            chatId
            cogarchRole
            currentSlide
            completed
            taskInstanceId
            presentationActivityId
            id
          }
        }
        ... on CaiSessionActivity {
          __typename
          sessionId
        }
      }
      isInActive
      lastSequence
      isTaskAssigned
      isReset
    }
  }
}
    `;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      taskId: // value for 'taskId'
 *      organizationId: // value for 'organizationId'
 *      stsOrganisationId: // value for 'stsOrganisationId'
 *      taskInstanceId: // value for 'taskInstanceId'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: Apollo.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export function useGetTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const GetTasksByProgramDocument = gql`
    query GetTasksByProgram($userId: ID!, $roleId: ID!, $programId: ID!, $filter: TaskProgramFilter, $organizationId: ID!) {
  tasksByProgram(
    userId: $userId
    roleId: $roleId
    programId: $programId
    organizationId: $organizationId
    filter: $filter
  ) {
    allTasks {
      title
      description
      id
      categories {
        name
      }
      isInActive
      lastSequence
      isTaskAssigned
      type
    }
    selectedTasks {
      title
      description
      id
      categories {
        name
      }
      isInActive
      lastSequence
      isTaskAssigned
      type
    }
    includedTasks {
      title
      description
      id
      categories {
        name
      }
      isInActive
      lastSequence
      isTaskAssigned
      type
    }
  }
}
    `;

/**
 * __useGetTasksByProgramQuery__
 *
 * To run a query within a React component, call `useGetTasksByProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByProgramQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *      filter: // value for 'filter'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetTasksByProgramQuery(baseOptions: Apollo.QueryHookOptions<GetTasksByProgramQuery, GetTasksByProgramQueryVariables> & ({ variables: GetTasksByProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>(GetTasksByProgramDocument, options);
      }
export function useGetTasksByProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>(GetTasksByProgramDocument, options);
        }
export function useGetTasksByProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>(GetTasksByProgramDocument, options);
        }
export type GetTasksByProgramQueryHookResult = ReturnType<typeof useGetTasksByProgramQuery>;
export type GetTasksByProgramLazyQueryHookResult = ReturnType<typeof useGetTasksByProgramLazyQuery>;
export type GetTasksByProgramSuspenseQueryHookResult = ReturnType<typeof useGetTasksByProgramSuspenseQuery>;
export type GetTasksByProgramQueryResult = Apollo.QueryResult<GetTasksByProgramQuery, GetTasksByProgramQueryVariables>;
export const GetTaskCategoriesDocument = gql`
    query GetTaskCategories {
  taskCategories {
    id
    name
  }
}
    `;

/**
 * __useGetTaskCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTaskCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaskCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>(GetTaskCategoriesDocument, options);
      }
export function useGetTaskCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>(GetTaskCategoriesDocument, options);
        }
export function useGetTaskCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>(GetTaskCategoriesDocument, options);
        }
export type GetTaskCategoriesQueryHookResult = ReturnType<typeof useGetTaskCategoriesQuery>;
export type GetTaskCategoriesLazyQueryHookResult = ReturnType<typeof useGetTaskCategoriesLazyQuery>;
export type GetTaskCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTaskCategoriesSuspenseQuery>;
export type GetTaskCategoriesQueryResult = Apollo.QueryResult<GetTaskCategoriesQuery, GetTaskCategoriesQueryVariables>;
export const AnswerMentorInstanceQuizDocument = gql`
    mutation AnswerMentorInstanceQuiz($input: MentorInstanceQuizAnswer!) {
  answerMentorInstanceQuiz(input: $input) {
    data
  }
}
    `;
export type AnswerMentorInstanceQuizMutationFn = Apollo.MutationFunction<AnswerMentorInstanceQuizMutation, AnswerMentorInstanceQuizMutationVariables>;

/**
 * __useAnswerMentorInstanceQuizMutation__
 *
 * To run a mutation, you first call `useAnswerMentorInstanceQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerMentorInstanceQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerMentorInstanceQuizMutation, { data, loading, error }] = useAnswerMentorInstanceQuizMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerMentorInstanceQuizMutation(baseOptions?: Apollo.MutationHookOptions<AnswerMentorInstanceQuizMutation, AnswerMentorInstanceQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerMentorInstanceQuizMutation, AnswerMentorInstanceQuizMutationVariables>(AnswerMentorInstanceQuizDocument, options);
      }
export type AnswerMentorInstanceQuizMutationHookResult = ReturnType<typeof useAnswerMentorInstanceQuizMutation>;
export type AnswerMentorInstanceQuizMutationResult = Apollo.MutationResult<AnswerMentorInstanceQuizMutation>;
export type AnswerMentorInstanceQuizMutationOptions = Apollo.BaseMutationOptions<AnswerMentorInstanceQuizMutation, AnswerMentorInstanceQuizMutationVariables>;
export const UpdateCurrentSlideNumberDocument = gql`
    mutation UpdateCurrentSlideNumber($presentationInstanceId: ID!, $presentationActivityId: ID!, $slideNumber: Int!) {
  updateCurrentSlideNumber(
    presentationInstanceId: $presentationInstanceId
    presentationActivityId: $presentationActivityId
    slideNumber: $slideNumber
  ) {
    data
    message
    success
  }
}
    `;
export type UpdateCurrentSlideNumberMutationFn = Apollo.MutationFunction<UpdateCurrentSlideNumberMutation, UpdateCurrentSlideNumberMutationVariables>;

/**
 * __useUpdateCurrentSlideNumberMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentSlideNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentSlideNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentSlideNumberMutation, { data, loading, error }] = useUpdateCurrentSlideNumberMutation({
 *   variables: {
 *      presentationInstanceId: // value for 'presentationInstanceId'
 *      presentationActivityId: // value for 'presentationActivityId'
 *      slideNumber: // value for 'slideNumber'
 *   },
 * });
 */
export function useUpdateCurrentSlideNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentSlideNumberMutation, UpdateCurrentSlideNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentSlideNumberMutation, UpdateCurrentSlideNumberMutationVariables>(UpdateCurrentSlideNumberDocument, options);
      }
export type UpdateCurrentSlideNumberMutationHookResult = ReturnType<typeof useUpdateCurrentSlideNumberMutation>;
export type UpdateCurrentSlideNumberMutationResult = Apollo.MutationResult<UpdateCurrentSlideNumberMutation>;
export type UpdateCurrentSlideNumberMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentSlideNumberMutation, UpdateCurrentSlideNumberMutationVariables>;
export const CompleteTaskActivityDocument = gql`
    mutation CompleteTaskActivity($activityId: ID, $activityInstanceId: ID, $activityType: String!, $sessionId: String) {
  completeTaskActivity(
    activityId: $activityId
    activityInstanceId: $activityInstanceId
    activityType: $activityType
    sessionId: $sessionId
  ) {
    success
  }
}
    `;
export type CompleteTaskActivityMutationFn = Apollo.MutationFunction<CompleteTaskActivityMutation, CompleteTaskActivityMutationVariables>;

/**
 * __useCompleteTaskActivityMutation__
 *
 * To run a mutation, you first call `useCompleteTaskActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTaskActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTaskActivityMutation, { data, loading, error }] = useCompleteTaskActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityInstanceId: // value for 'activityInstanceId'
 *      activityType: // value for 'activityType'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useCompleteTaskActivityMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTaskActivityMutation, CompleteTaskActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTaskActivityMutation, CompleteTaskActivityMutationVariables>(CompleteTaskActivityDocument, options);
      }
export type CompleteTaskActivityMutationHookResult = ReturnType<typeof useCompleteTaskActivityMutation>;
export type CompleteTaskActivityMutationResult = Apollo.MutationResult<CompleteTaskActivityMutation>;
export type CompleteTaskActivityMutationOptions = Apollo.BaseMutationOptions<CompleteTaskActivityMutation, CompleteTaskActivityMutationVariables>;
export const RetakeTaskDocument = gql`
    mutation RetakeTask($userId: ID!, $taskId: ID!, $taskInstanceId: ID!) {
  retakeTask(userId: $userId, taskId: $taskId, taskInstanceId: $taskInstanceId) {
    data
    success
  }
}
    `;
export type RetakeTaskMutationFn = Apollo.MutationFunction<RetakeTaskMutation, RetakeTaskMutationVariables>;

/**
 * __useRetakeTaskMutation__
 *
 * To run a mutation, you first call `useRetakeTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetakeTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retakeTaskMutation, { data, loading, error }] = useRetakeTaskMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      taskId: // value for 'taskId'
 *      taskInstanceId: // value for 'taskInstanceId'
 *   },
 * });
 */
export function useRetakeTaskMutation(baseOptions?: Apollo.MutationHookOptions<RetakeTaskMutation, RetakeTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetakeTaskMutation, RetakeTaskMutationVariables>(RetakeTaskDocument, options);
      }
export type RetakeTaskMutationHookResult = ReturnType<typeof useRetakeTaskMutation>;
export type RetakeTaskMutationResult = Apollo.MutationResult<RetakeTaskMutation>;
export type RetakeTaskMutationOptions = Apollo.BaseMutationOptions<RetakeTaskMutation, RetakeTaskMutationVariables>;
export const GetTasksDocument = gql`
    query GetTasks($organizationId: ID!, $roleId: ID!, $currentPage: Int, $pageSize: Int, $filter: TaskFilter) {
  tasks(
    organizationId: $organizationId
    roleId: $roleId
    currentPage: $currentPage
    pageSize: $pageSize
    filter: $filter
  ) {
    tasks {
      updatedAt
      createdBy {
        employeeDetails {
          firstName
          lastName
          middleName
        }
      }
      id
      title
      attachmentIds
      description
      categories {
        name
      }
      isInActive
      createdAt
      lastSequence
      isTaskAssigned
      type
      s3Bucket
      s3Location
      s3Key
    }
    totalItems
  }
}
    `;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      roleId: // value for 'roleId'
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables> & ({ variables: GetTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetUserTeamsDocument = gql`
    query GetUserTeams {
  userTeams {
    id
    name
  }
}
    `;

/**
 * __useGetUserTeamsQuery__
 *
 * To run a query within a React component, call `useGetUserTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(GetUserTeamsDocument, options);
      }
export function useGetUserTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(GetUserTeamsDocument, options);
        }
export function useGetUserTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserTeamsQuery, GetUserTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTeamsQuery, GetUserTeamsQueryVariables>(GetUserTeamsDocument, options);
        }
export type GetUserTeamsQueryHookResult = ReturnType<typeof useGetUserTeamsQuery>;
export type GetUserTeamsLazyQueryHookResult = ReturnType<typeof useGetUserTeamsLazyQuery>;
export type GetUserTeamsSuspenseQueryHookResult = ReturnType<typeof useGetUserTeamsSuspenseQuery>;
export type GetUserTeamsQueryResult = Apollo.QueryResult<GetUserTeamsQuery, GetUserTeamsQueryVariables>;
export const GetTeamsDocument = gql`
    query GetTeams($organizationId: ID, $filter: TeamFilter) {
  teams(organizationId: $organizationId, filter: $filter) {
    id
    name
    owner {
      employeeDetails {
        firstName
        middleName
        lastName
        avatar
      }
    }
    members {
      memberId
      email
      employeeDetails {
        avatar
        employeeId
        firstName
        middleName
        lastName
      }
      isManager
    }
  }
}
    `;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
      }
export function useGetTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export function useGetTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsSuspenseQueryHookResult = ReturnType<typeof useGetTeamsSuspenseQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const GetQuizStatisticDocument = gql`
    query GetQuizStatistic($userId: ID!, $activityId: ID!, $activityInstanceId: ID!, $taskInstanceId: ID!) {
  quizStatistic(
    userId: $userId
    activityId: $activityId
    activityInstanceId: $activityInstanceId
    taskInstanceId: $taskInstanceId
  ) {
    data
    totalNumberOfQuizzes
  }
}
    `;

/**
 * __useGetQuizStatisticQuery__
 *
 * To run a query within a React component, call `useGetQuizStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizStatisticQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      activityId: // value for 'activityId'
 *      activityInstanceId: // value for 'activityInstanceId'
 *      taskInstanceId: // value for 'taskInstanceId'
 *   },
 * });
 */
export function useGetQuizStatisticQuery(baseOptions: Apollo.QueryHookOptions<GetQuizStatisticQuery, GetQuizStatisticQueryVariables> & ({ variables: GetQuizStatisticQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>(GetQuizStatisticDocument, options);
      }
export function useGetQuizStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>(GetQuizStatisticDocument, options);
        }
export function useGetQuizStatisticSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>(GetQuizStatisticDocument, options);
        }
export type GetQuizStatisticQueryHookResult = ReturnType<typeof useGetQuizStatisticQuery>;
export type GetQuizStatisticLazyQueryHookResult = ReturnType<typeof useGetQuizStatisticLazyQuery>;
export type GetQuizStatisticSuspenseQueryHookResult = ReturnType<typeof useGetQuizStatisticSuspenseQuery>;
export type GetQuizStatisticQueryResult = Apollo.QueryResult<GetQuizStatisticQuery, GetQuizStatisticQueryVariables>;
export const AssignProgramDocument = gql`
    mutation AssignProgram($input: AssignProgramInput) {
  assignProgram(input: $input) {
    success
  }
}
    `;
export type AssignProgramMutationFn = Apollo.MutationFunction<AssignProgramMutation, AssignProgramMutationVariables>;

/**
 * __useAssignProgramMutation__
 *
 * To run a mutation, you first call `useAssignProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignProgramMutation, { data, loading, error }] = useAssignProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignProgramMutation(baseOptions?: Apollo.MutationHookOptions<AssignProgramMutation, AssignProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignProgramMutation, AssignProgramMutationVariables>(AssignProgramDocument, options);
      }
export type AssignProgramMutationHookResult = ReturnType<typeof useAssignProgramMutation>;
export type AssignProgramMutationResult = Apollo.MutationResult<AssignProgramMutation>;
export type AssignProgramMutationOptions = Apollo.BaseMutationOptions<AssignProgramMutation, AssignProgramMutationVariables>;
export const AssignTaskDocument = gql`
    mutation AssignTask($input: AssignTaskInput) {
  assignTask(input: $input) {
    success
  }
}
    `;
export type AssignTaskMutationFn = Apollo.MutationFunction<AssignTaskMutation, AssignTaskMutationVariables>;

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(baseOptions?: Apollo.MutationHookOptions<AssignTaskMutation, AssignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTaskMutation, AssignTaskMutationVariables>(AssignTaskDocument, options);
      }
export type AssignTaskMutationHookResult = ReturnType<typeof useAssignTaskMutation>;
export type AssignTaskMutationResult = Apollo.MutationResult<AssignTaskMutation>;
export type AssignTaskMutationOptions = Apollo.BaseMutationOptions<AssignTaskMutation, AssignTaskMutationVariables>;
export const UnassignProgramDocument = gql`
    mutation UnassignProgram($input: UnassignProgramInput) {
  unassignProgram(input: $input) {
    success
  }
}
    `;
export type UnassignProgramMutationFn = Apollo.MutationFunction<UnassignProgramMutation, UnassignProgramMutationVariables>;

/**
 * __useUnassignProgramMutation__
 *
 * To run a mutation, you first call `useUnassignProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignProgramMutation, { data, loading, error }] = useUnassignProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignProgramMutation(baseOptions?: Apollo.MutationHookOptions<UnassignProgramMutation, UnassignProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignProgramMutation, UnassignProgramMutationVariables>(UnassignProgramDocument, options);
      }
export type UnassignProgramMutationHookResult = ReturnType<typeof useUnassignProgramMutation>;
export type UnassignProgramMutationResult = Apollo.MutationResult<UnassignProgramMutation>;
export type UnassignProgramMutationOptions = Apollo.BaseMutationOptions<UnassignProgramMutation, UnassignProgramMutationVariables>;
export const GetProgramCategoriesDocument = gql`
    query GetProgramCategories {
  programCategories {
    id
    name
  }
}
    `;

/**
 * __useGetProgramCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProgramCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProgramCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>(GetProgramCategoriesDocument, options);
      }
export function useGetProgramCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>(GetProgramCategoriesDocument, options);
        }
export function useGetProgramCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>(GetProgramCategoriesDocument, options);
        }
export type GetProgramCategoriesQueryHookResult = ReturnType<typeof useGetProgramCategoriesQuery>;
export type GetProgramCategoriesLazyQueryHookResult = ReturnType<typeof useGetProgramCategoriesLazyQuery>;
export type GetProgramCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetProgramCategoriesSuspenseQuery>;
export type GetProgramCategoriesQueryResult = Apollo.QueryResult<GetProgramCategoriesQuery, GetProgramCategoriesQueryVariables>;
export const SaveProgramDocument = gql`
    mutation SaveProgram($userId: ID!, $roleId: ID!, $input: SaveProgramInput) {
  saveProgram(userId: $userId, roleId: $roleId, input: $input) {
    success
  }
}
    `;
export type SaveProgramMutationFn = Apollo.MutationFunction<SaveProgramMutation, SaveProgramMutationVariables>;

/**
 * __useSaveProgramMutation__
 *
 * To run a mutation, you first call `useSaveProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProgramMutation, { data, loading, error }] = useSaveProgramMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProgramMutation(baseOptions?: Apollo.MutationHookOptions<SaveProgramMutation, SaveProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProgramMutation, SaveProgramMutationVariables>(SaveProgramDocument, options);
      }
export type SaveProgramMutationHookResult = ReturnType<typeof useSaveProgramMutation>;
export type SaveProgramMutationResult = Apollo.MutationResult<SaveProgramMutation>;
export type SaveProgramMutationOptions = Apollo.BaseMutationOptions<SaveProgramMutation, SaveProgramMutationVariables>;
export const ResetUserToDemoStateDocument = gql`
    mutation ResetUserToDemoState($organizationId: ID!) {
  resetUserToDemoState(organizationId: $organizationId) {
    success
  }
}
    `;
export type ResetUserToDemoStateMutationFn = Apollo.MutationFunction<ResetUserToDemoStateMutation, ResetUserToDemoStateMutationVariables>;

/**
 * __useResetUserToDemoStateMutation__
 *
 * To run a mutation, you first call `useResetUserToDemoStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserToDemoStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserToDemoStateMutation, { data, loading, error }] = useResetUserToDemoStateMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useResetUserToDemoStateMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserToDemoStateMutation, ResetUserToDemoStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserToDemoStateMutation, ResetUserToDemoStateMutationVariables>(ResetUserToDemoStateDocument, options);
      }
export type ResetUserToDemoStateMutationHookResult = ReturnType<typeof useResetUserToDemoStateMutation>;
export type ResetUserToDemoStateMutationResult = Apollo.MutationResult<ResetUserToDemoStateMutation>;
export type ResetUserToDemoStateMutationOptions = Apollo.BaseMutationOptions<ResetUserToDemoStateMutation, ResetUserToDemoStateMutationVariables>;
export const UpdateProgramTaskStatusDocument = gql`
    mutation UpdateProgramTaskStatus($userId: ID!, $roleId: ID!, $programId: ID!, $taskId: ID!, $stsOrganisationId: ID!, $source: String!, $target: String!) {
  updateProgramTaskStatus(
    userId: $userId
    roleId: $roleId
    programId: $programId
    taskId: $taskId
    stsOrganisationId: $stsOrganisationId
    source: $source
    target: $target
  ) {
    success
  }
}
    `;
export type UpdateProgramTaskStatusMutationFn = Apollo.MutationFunction<UpdateProgramTaskStatusMutation, UpdateProgramTaskStatusMutationVariables>;

/**
 * __useUpdateProgramTaskStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProgramTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramTaskStatusMutation, { data, loading, error }] = useUpdateProgramTaskStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *      taskId: // value for 'taskId'
 *      stsOrganisationId: // value for 'stsOrganisationId'
 *      source: // value for 'source'
 *      target: // value for 'target'
 *   },
 * });
 */
export function useUpdateProgramTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramTaskStatusMutation, UpdateProgramTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramTaskStatusMutation, UpdateProgramTaskStatusMutationVariables>(UpdateProgramTaskStatusDocument, options);
      }
export type UpdateProgramTaskStatusMutationHookResult = ReturnType<typeof useUpdateProgramTaskStatusMutation>;
export type UpdateProgramTaskStatusMutationResult = Apollo.MutationResult<UpdateProgramTaskStatusMutation>;
export type UpdateProgramTaskStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProgramTaskStatusMutation, UpdateProgramTaskStatusMutationVariables>;
export const PublishProgramDocument = gql`
    mutation PublishProgram($userId: ID!, $roleId: ID!, $programId: ID!) {
  publishProgram(userId: $userId, roleId: $roleId, programId: $programId) {
    success
  }
}
    `;
export type PublishProgramMutationFn = Apollo.MutationFunction<PublishProgramMutation, PublishProgramMutationVariables>;

/**
 * __usePublishProgramMutation__
 *
 * To run a mutation, you first call `usePublishProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishProgramMutation, { data, loading, error }] = usePublishProgramMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function usePublishProgramMutation(baseOptions?: Apollo.MutationHookOptions<PublishProgramMutation, PublishProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishProgramMutation, PublishProgramMutationVariables>(PublishProgramDocument, options);
      }
export type PublishProgramMutationHookResult = ReturnType<typeof usePublishProgramMutation>;
export type PublishProgramMutationResult = Apollo.MutationResult<PublishProgramMutation>;
export type PublishProgramMutationOptions = Apollo.BaseMutationOptions<PublishProgramMutation, PublishProgramMutationVariables>;
export const GetAssignedTasksByProgramDocument = gql`
    query GetAssignedTasksByProgram($userId: ID!, $roleId: ID!, $programId: ID!) {
  assignedTasksByProgram(userId: $userId, roleId: $roleId, programId: $programId) {
    assignee {
      status
      employeeDetails {
        employeeId
        avatar
        firstName
        middleName
        lastName
      }
      endDate
    }
    isInActive
    title
    description
    categories {
      name
    }
    id
    taskInstanceId
    lastSequence
    isTaskAssigned
    type
  }
}
    `;

/**
 * __useGetAssignedTasksByProgramQuery__
 *
 * To run a query within a React component, call `useGetAssignedTasksByProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignedTasksByProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignedTasksByProgramQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetAssignedTasksByProgramQuery(baseOptions: Apollo.QueryHookOptions<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables> & ({ variables: GetAssignedTasksByProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>(GetAssignedTasksByProgramDocument, options);
      }
export function useGetAssignedTasksByProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>(GetAssignedTasksByProgramDocument, options);
        }
export function useGetAssignedTasksByProgramSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>(GetAssignedTasksByProgramDocument, options);
        }
export type GetAssignedTasksByProgramQueryHookResult = ReturnType<typeof useGetAssignedTasksByProgramQuery>;
export type GetAssignedTasksByProgramLazyQueryHookResult = ReturnType<typeof useGetAssignedTasksByProgramLazyQuery>;
export type GetAssignedTasksByProgramSuspenseQueryHookResult = ReturnType<typeof useGetAssignedTasksByProgramSuspenseQuery>;
export type GetAssignedTasksByProgramQueryResult = Apollo.QueryResult<GetAssignedTasksByProgramQuery, GetAssignedTasksByProgramQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations {
  organizations {
    id
    name
    category
    ownerId
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($id: ID!) {
  organization(id: $id) {
    id
    name
    industry
    type
    logo
    stsOrganisationId
    category
    defaultLanguage
    ownerId
    userOrganizations {
      userId
      isActive
      user {
        id
        email
      }
    }
    usagePlan
    memberCount
    workspaceCost
    documentCount
    lastResetDate
    subscriptionDetails {
      id
      status
      nextBillingDate
      currentPeriodStart
      currentPeriodEnd
      nextCycleAmount
      currentCycleAmount
      reserveTokens
      customerId
      lastInvoiceUrl
      dateToBeDowngraded
      unitPrice
      subscribedSeats
    }
    stripeUpgradePrompt {
      id
      gracePeriodEnd
      organizationId
      reason
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationByStsIdDocument = gql`
    query GetOrganizationByStsId($stsOrganisationId: ID!) {
  organizationByStsId(stsOrganisationId: $stsOrganisationId) {
    id
    name
    industry
    type
    logo
    stsOrganisationId
    category
    defaultLanguage
    ownerId
    userOrganizations {
      userId
      isActive
      user {
        id
        email
      }
    }
    usagePlan
    memberCount
    workspaceCost
    documentCount
    lastResetDate
    subscriptionDetails {
      id
      status
      nextBillingDate
      currentPeriodStart
      currentPeriodEnd
      nextCycleAmount
      currentCycleAmount
      reserveTokens
      customerId
      lastInvoiceUrl
      dateToBeDowngraded
      unitPrice
      subscribedSeats
    }
    stripeUpgradePrompt {
      id
      gracePeriodEnd
      organizationId
      reason
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetOrganizationByStsIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationByStsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationByStsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationByStsIdQuery({
 *   variables: {
 *      stsOrganisationId: // value for 'stsOrganisationId'
 *   },
 * });
 */
export function useGetOrganizationByStsIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables> & ({ variables: GetOrganizationByStsIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>(GetOrganizationByStsIdDocument, options);
      }
export function useGetOrganizationByStsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>(GetOrganizationByStsIdDocument, options);
        }
export function useGetOrganizationByStsIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>(GetOrganizationByStsIdDocument, options);
        }
export type GetOrganizationByStsIdQueryHookResult = ReturnType<typeof useGetOrganizationByStsIdQuery>;
export type GetOrganizationByStsIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationByStsIdLazyQuery>;
export type GetOrganizationByStsIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationByStsIdSuspenseQuery>;
export type GetOrganizationByStsIdQueryResult = Apollo.QueryResult<GetOrganizationByStsIdQuery, GetOrganizationByStsIdQueryVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices($organizationId: ID!) {
  invoices(organizationId: $organizationId) {
    id
    organizationId
    date
    total
    originalAmount
    discount
    url
    description
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables> & ({ variables: GetInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetLatestOrganizationInvoiceDocument = gql`
    query GetLatestOrganizationInvoice($organizationId: ID!) {
  latestOrganizationInvoice(organizationId: $organizationId) {
    id
    organizationId
    date
    total
    originalAmount
    discount
    url
    description
  }
}
    `;

/**
 * __useGetLatestOrganizationInvoiceQuery__
 *
 * To run a query within a React component, call `useGetLatestOrganizationInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestOrganizationInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestOrganizationInvoiceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetLatestOrganizationInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables> & ({ variables: GetLatestOrganizationInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>(GetLatestOrganizationInvoiceDocument, options);
      }
export function useGetLatestOrganizationInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>(GetLatestOrganizationInvoiceDocument, options);
        }
export function useGetLatestOrganizationInvoiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>(GetLatestOrganizationInvoiceDocument, options);
        }
export type GetLatestOrganizationInvoiceQueryHookResult = ReturnType<typeof useGetLatestOrganizationInvoiceQuery>;
export type GetLatestOrganizationInvoiceLazyQueryHookResult = ReturnType<typeof useGetLatestOrganizationInvoiceLazyQuery>;
export type GetLatestOrganizationInvoiceSuspenseQueryHookResult = ReturnType<typeof useGetLatestOrganizationInvoiceSuspenseQuery>;
export type GetLatestOrganizationInvoiceQueryResult = Apollo.QueryResult<GetLatestOrganizationInvoiceQuery, GetLatestOrganizationInvoiceQueryVariables>;
export const GetUserDailyTokenUsageDocument = gql`
    query GetUserDailyTokenUsage($organizationId: ID!, $userId: ID!) {
  userDailyTokenUsage(organizationId: $organizationId, userId: $userId) {
    id
    userId
    organizationId
    date
    tokensUsed
  }
}
    `;

/**
 * __useGetUserDailyTokenUsageQuery__
 *
 * To run a query within a React component, call `useGetUserDailyTokenUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDailyTokenUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDailyTokenUsageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserDailyTokenUsageQuery(baseOptions: Apollo.QueryHookOptions<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables> & ({ variables: GetUserDailyTokenUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>(GetUserDailyTokenUsageDocument, options);
      }
export function useGetUserDailyTokenUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>(GetUserDailyTokenUsageDocument, options);
        }
export function useGetUserDailyTokenUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>(GetUserDailyTokenUsageDocument, options);
        }
export type GetUserDailyTokenUsageQueryHookResult = ReturnType<typeof useGetUserDailyTokenUsageQuery>;
export type GetUserDailyTokenUsageLazyQueryHookResult = ReturnType<typeof useGetUserDailyTokenUsageLazyQuery>;
export type GetUserDailyTokenUsageSuspenseQueryHookResult = ReturnType<typeof useGetUserDailyTokenUsageSuspenseQuery>;
export type GetUserDailyTokenUsageQueryResult = Apollo.QueryResult<GetUserDailyTokenUsageQuery, GetUserDailyTokenUsageQueryVariables>;
export const GetTokenPackCostDocument = gql`
    query GetTokenPackCost($tokenAmount: Int!) {
  tokenPackCost(tokenAmount: $tokenAmount) {
    tokenAmount
    totalCost
    lineItems {
      productName
      tokenAmount
      cost
      quantity
    }
  }
}
    `;

/**
 * __useGetTokenPackCostQuery__
 *
 * To run a query within a React component, call `useGetTokenPackCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenPackCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenPackCostQuery({
 *   variables: {
 *      tokenAmount: // value for 'tokenAmount'
 *   },
 * });
 */
export function useGetTokenPackCostQuery(baseOptions: Apollo.QueryHookOptions<GetTokenPackCostQuery, GetTokenPackCostQueryVariables> & ({ variables: GetTokenPackCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>(GetTokenPackCostDocument, options);
      }
export function useGetTokenPackCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>(GetTokenPackCostDocument, options);
        }
export function useGetTokenPackCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>(GetTokenPackCostDocument, options);
        }
export type GetTokenPackCostQueryHookResult = ReturnType<typeof useGetTokenPackCostQuery>;
export type GetTokenPackCostLazyQueryHookResult = ReturnType<typeof useGetTokenPackCostLazyQuery>;
export type GetTokenPackCostSuspenseQueryHookResult = ReturnType<typeof useGetTokenPackCostSuspenseQuery>;
export type GetTokenPackCostQueryResult = Apollo.QueryResult<GetTokenPackCostQuery, GetTokenPackCostQueryVariables>;
export const GetWorkspaceCostDocument = gql`
    query GetWorkspaceCost($organizationId: ID!, $memberCount: Int!, $usagePlan: OrganizationUsagePlan) {
  workspaceCost(
    organizationId: $organizationId
    memberCount: $memberCount
    usagePlan: $usagePlan
  )
}
    `;

/**
 * __useGetWorkspaceCostQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceCostQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      memberCount: // value for 'memberCount'
 *      usagePlan: // value for 'usagePlan'
 *   },
 * });
 */
export function useGetWorkspaceCostQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables> & ({ variables: GetWorkspaceCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>(GetWorkspaceCostDocument, options);
      }
export function useGetWorkspaceCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>(GetWorkspaceCostDocument, options);
        }
export function useGetWorkspaceCostSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>(GetWorkspaceCostDocument, options);
        }
export type GetWorkspaceCostQueryHookResult = ReturnType<typeof useGetWorkspaceCostQuery>;
export type GetWorkspaceCostLazyQueryHookResult = ReturnType<typeof useGetWorkspaceCostLazyQuery>;
export type GetWorkspaceCostSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceCostSuspenseQuery>;
export type GetWorkspaceCostQueryResult = Apollo.QueryResult<GetWorkspaceCostQuery, GetWorkspaceCostQueryVariables>;
export const PurchaseTokenPackDocument = gql`
    mutation PurchaseTokenPack($organizationId: ID!, $tokenAmount: Int!) {
  purchaseTokenPack(organizationId: $organizationId, tokenAmount: $tokenAmount) {
    sessionId
    sessionUrl
  }
}
    `;
export type PurchaseTokenPackMutationFn = Apollo.MutationFunction<PurchaseTokenPackMutation, PurchaseTokenPackMutationVariables>;

/**
 * __usePurchaseTokenPackMutation__
 *
 * To run a mutation, you first call `usePurchaseTokenPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseTokenPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseTokenPackMutation, { data, loading, error }] = usePurchaseTokenPackMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      tokenAmount: // value for 'tokenAmount'
 *   },
 * });
 */
export function usePurchaseTokenPackMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseTokenPackMutation, PurchaseTokenPackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseTokenPackMutation, PurchaseTokenPackMutationVariables>(PurchaseTokenPackDocument, options);
      }
export type PurchaseTokenPackMutationHookResult = ReturnType<typeof usePurchaseTokenPackMutation>;
export type PurchaseTokenPackMutationResult = Apollo.MutationResult<PurchaseTokenPackMutation>;
export type PurchaseTokenPackMutationOptions = Apollo.BaseMutationOptions<PurchaseTokenPackMutation, PurchaseTokenPackMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($organizationId: ID!, $planType: OrganizationUsagePlan, $desiredSeats: Int!) {
  createSubscription(
    organizationId: $organizationId
    planType: $planType
    desiredSeats: $desiredSeats
  ) {
    sessionId
    sessionUrl
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      planType: // value for 'planType'
 *      desiredSeats: // value for 'desiredSeats'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const PurchaseAdditionalSeatsDocument = gql`
    mutation PurchaseAdditionalSeats($organizationId: ID!, $desiredSeats: Int!) {
  purchaseAdditionalSeats(
    organizationId: $organizationId
    desiredSeats: $desiredSeats
  ) {
    sessionId
    sessionUrl
  }
}
    `;
export type PurchaseAdditionalSeatsMutationFn = Apollo.MutationFunction<PurchaseAdditionalSeatsMutation, PurchaseAdditionalSeatsMutationVariables>;

/**
 * __usePurchaseAdditionalSeatsMutation__
 *
 * To run a mutation, you first call `usePurchaseAdditionalSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseAdditionalSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseAdditionalSeatsMutation, { data, loading, error }] = usePurchaseAdditionalSeatsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      desiredSeats: // value for 'desiredSeats'
 *   },
 * });
 */
export function usePurchaseAdditionalSeatsMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseAdditionalSeatsMutation, PurchaseAdditionalSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseAdditionalSeatsMutation, PurchaseAdditionalSeatsMutationVariables>(PurchaseAdditionalSeatsDocument, options);
      }
export type PurchaseAdditionalSeatsMutationHookResult = ReturnType<typeof usePurchaseAdditionalSeatsMutation>;
export type PurchaseAdditionalSeatsMutationResult = Apollo.MutationResult<PurchaseAdditionalSeatsMutation>;
export type PurchaseAdditionalSeatsMutationOptions = Apollo.BaseMutationOptions<PurchaseAdditionalSeatsMutation, PurchaseAdditionalSeatsMutationVariables>;
export const ScheduleDowngradeSubscriptionDocument = gql`
    mutation ScheduleDowngradeSubscription($organizationId: ID!, $targetPlan: OrganizationUsagePlan!) {
  scheduleDowngradeSubscription(
    organizationId: $organizationId
    targetPlan: $targetPlan
  ) {
    success
    message
  }
}
    `;
export type ScheduleDowngradeSubscriptionMutationFn = Apollo.MutationFunction<ScheduleDowngradeSubscriptionMutation, ScheduleDowngradeSubscriptionMutationVariables>;

/**
 * __useScheduleDowngradeSubscriptionMutation__
 *
 * To run a mutation, you first call `useScheduleDowngradeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDowngradeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDowngradeSubscriptionMutation, { data, loading, error }] = useScheduleDowngradeSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      targetPlan: // value for 'targetPlan'
 *   },
 * });
 */
export function useScheduleDowngradeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDowngradeSubscriptionMutation, ScheduleDowngradeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDowngradeSubscriptionMutation, ScheduleDowngradeSubscriptionMutationVariables>(ScheduleDowngradeSubscriptionDocument, options);
      }
export type ScheduleDowngradeSubscriptionMutationHookResult = ReturnType<typeof useScheduleDowngradeSubscriptionMutation>;
export type ScheduleDowngradeSubscriptionMutationResult = Apollo.MutationResult<ScheduleDowngradeSubscriptionMutation>;
export type ScheduleDowngradeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ScheduleDowngradeSubscriptionMutation, ScheduleDowngradeSubscriptionMutationVariables>;
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    id
    zipCode
    region
    state
    country
    zone
    global
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const SaveUserDocument = gql`
    mutation SaveUser($userId: ID!, $roleId: ID!, $organizationId: ID!, $input: SaveUserInput) {
  saveUser(
    userId: $userId
    roleId: $roleId
    organizationId: $organizationId
    input: $input
  ) {
    data
    message
    success
  }
}
    `;
export type SaveUserMutationFn = Apollo.MutationFunction<SaveUserMutation, SaveUserMutationVariables>;

/**
 * __useSaveUserMutation__
 *
 * To run a mutation, you first call `useSaveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserMutation, { data, loading, error }] = useSaveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserMutation, SaveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserMutation, SaveUserMutationVariables>(SaveUserDocument, options);
      }
export type SaveUserMutationHookResult = ReturnType<typeof useSaveUserMutation>;
export type SaveUserMutationResult = Apollo.MutationResult<SaveUserMutation>;
export type SaveUserMutationOptions = Apollo.BaseMutationOptions<SaveUserMutation, SaveUserMutationVariables>;
export const AddUserToOrganisationDocument = gql`
    mutation AddUserToOrganisation($stsUserId: ID, $stsOrganisationId: ID) {
  addUserToOrganisation(
    stsUserId: $stsUserId
    stsOrganisationId: $stsOrganisationId
  ) {
    data
    message
    success
  }
}
    `;
export type AddUserToOrganisationMutationFn = Apollo.MutationFunction<AddUserToOrganisationMutation, AddUserToOrganisationMutationVariables>;

/**
 * __useAddUserToOrganisationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganisationMutation, { data, loading, error }] = useAddUserToOrganisationMutation({
 *   variables: {
 *      stsUserId: // value for 'stsUserId'
 *      stsOrganisationId: // value for 'stsOrganisationId'
 *   },
 * });
 */
export function useAddUserToOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToOrganisationMutation, AddUserToOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToOrganisationMutation, AddUserToOrganisationMutationVariables>(AddUserToOrganisationDocument, options);
      }
export type AddUserToOrganisationMutationHookResult = ReturnType<typeof useAddUserToOrganisationMutation>;
export type AddUserToOrganisationMutationResult = Apollo.MutationResult<AddUserToOrganisationMutation>;
export type AddUserToOrganisationMutationOptions = Apollo.BaseMutationOptions<AddUserToOrganisationMutation, AddUserToOrganisationMutationVariables>;
export const SaveCompanyDocument = gql`
    mutation SaveCompany($userId: ID!, $roleId: ID!, $input: SaveCompanyInput) {
  saveCompany(userId: $userId, roleId: $roleId, input: $input) {
    data
    message
    success
  }
}
    `;
export type SaveCompanyMutationFn = Apollo.MutationFunction<SaveCompanyMutation, SaveCompanyMutationVariables>;

/**
 * __useSaveCompanyMutation__
 *
 * To run a mutation, you first call `useSaveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompanyMutation, { data, loading, error }] = useSaveCompanyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SaveCompanyMutation, SaveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCompanyMutation, SaveCompanyMutationVariables>(SaveCompanyDocument, options);
      }
export type SaveCompanyMutationHookResult = ReturnType<typeof useSaveCompanyMutation>;
export type SaveCompanyMutationResult = Apollo.MutationResult<SaveCompanyMutation>;
export type SaveCompanyMutationOptions = Apollo.BaseMutationOptions<SaveCompanyMutation, SaveCompanyMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    data
    message
    success
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdatePreviousBubbleIdDocument = gql`
    mutation UpdatePreviousBubbleId($userId: ID!, $caiInstanceId: ID!, $bubbleId: String) {
  updatePreviousBubbleId(
    userId: $userId
    caiInstanceId: $caiInstanceId
    bubbleId: $bubbleId
  ) {
    success
    data
    message
  }
}
    `;
export type UpdatePreviousBubbleIdMutationFn = Apollo.MutationFunction<UpdatePreviousBubbleIdMutation, UpdatePreviousBubbleIdMutationVariables>;

/**
 * __useUpdatePreviousBubbleIdMutation__
 *
 * To run a mutation, you first call `useUpdatePreviousBubbleIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreviousBubbleIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreviousBubbleIdMutation, { data, loading, error }] = useUpdatePreviousBubbleIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      caiInstanceId: // value for 'caiInstanceId'
 *      bubbleId: // value for 'bubbleId'
 *   },
 * });
 */
export function useUpdatePreviousBubbleIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreviousBubbleIdMutation, UpdatePreviousBubbleIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreviousBubbleIdMutation, UpdatePreviousBubbleIdMutationVariables>(UpdatePreviousBubbleIdDocument, options);
      }
export type UpdatePreviousBubbleIdMutationHookResult = ReturnType<typeof useUpdatePreviousBubbleIdMutation>;
export type UpdatePreviousBubbleIdMutationResult = Apollo.MutationResult<UpdatePreviousBubbleIdMutation>;
export type UpdatePreviousBubbleIdMutationOptions = Apollo.BaseMutationOptions<UpdatePreviousBubbleIdMutation, UpdatePreviousBubbleIdMutationVariables>;
export const GetAnnouncementsDocument = gql`
    query GetAnnouncements($organizationId: ID!) {
  announcements(organizationId: $organizationId) {
    id
    organizationId
    icon
    title
    body
  }
}
    `;

/**
 * __useGetAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables> & ({ variables: GetAnnouncementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
      }
export function useGetAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
        }
export function useGetAnnouncementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
        }
export type GetAnnouncementsQueryHookResult = ReturnType<typeof useGetAnnouncementsQuery>;
export type GetAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsLazyQuery>;
export type GetAnnouncementsSuspenseQueryHookResult = ReturnType<typeof useGetAnnouncementsSuspenseQuery>;
export type GetAnnouncementsQueryResult = Apollo.QueryResult<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>;
export const GetDocumentsDocument = gql`
    query GetDocuments($organizationId: ID!) {
  documents(organizationId: $organizationId) {
    id
    createdBy {
      employeeDetails {
        firstName
        lastName
        middleName
        avatar
      }
    }
    organizationId
    title
    updatedAt
    s3Location
    s3Bucket
    s3Key
    cogarchEmbeddingId
    createdAt
  }
}
    `;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables> & ({ variables: GetDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export function useGetDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsSuspenseQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetTreeDocumentsDocument = gql`
    query GetTreeDocuments($organizationId: ID!) {
  treeDocuments(organizationId: $organizationId)
}
    `;

/**
 * __useGetTreeDocumentsQuery__
 *
 * To run a query within a React component, call `useGetTreeDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreeDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreeDocumentsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetTreeDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables> & ({ variables: GetTreeDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>(GetTreeDocumentsDocument, options);
      }
export function useGetTreeDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>(GetTreeDocumentsDocument, options);
        }
export function useGetTreeDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>(GetTreeDocumentsDocument, options);
        }
export type GetTreeDocumentsQueryHookResult = ReturnType<typeof useGetTreeDocumentsQuery>;
export type GetTreeDocumentsLazyQueryHookResult = ReturnType<typeof useGetTreeDocumentsLazyQuery>;
export type GetTreeDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetTreeDocumentsSuspenseQuery>;
export type GetTreeDocumentsQueryResult = Apollo.QueryResult<GetTreeDocumentsQuery, GetTreeDocumentsQueryVariables>;
export const GetStarterProgramsDocument = gql`
    query GetStarterPrograms($currentPage: Int, $pageSize: Int) {
  starterPrograms(currentPage: $currentPage, pageSize: $pageSize) {
    starterPrograms {
      id
      organizationType
      language
      programIds
      updatedAt
      createdAt
    }
    totalItems
  }
}
    `;

/**
 * __useGetStarterProgramsQuery__
 *
 * To run a query within a React component, call `useGetStarterProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStarterProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStarterProgramsQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetStarterProgramsQuery(baseOptions?: Apollo.QueryHookOptions<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>(GetStarterProgramsDocument, options);
      }
export function useGetStarterProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>(GetStarterProgramsDocument, options);
        }
export function useGetStarterProgramsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>(GetStarterProgramsDocument, options);
        }
export type GetStarterProgramsQueryHookResult = ReturnType<typeof useGetStarterProgramsQuery>;
export type GetStarterProgramsLazyQueryHookResult = ReturnType<typeof useGetStarterProgramsLazyQuery>;
export type GetStarterProgramsSuspenseQueryHookResult = ReturnType<typeof useGetStarterProgramsSuspenseQuery>;
export type GetStarterProgramsQueryResult = Apollo.QueryResult<GetStarterProgramsQuery, GetStarterProgramsQueryVariables>;
export const GetPaginatedOrganizationsDocument = gql`
    query GetPaginatedOrganizations($filter: OrganizationFilter, $currentPage: Int, $pageSize: Int) {
  paginatedOrganizations(
    filter: $filter
    currentPage: $currentPage
    pageSize: $pageSize
  ) {
    organizations {
      id
      name
      industry
      type
      logo
      stsOrganisationId
      category
      defaultLanguage
      markDeleted
      usagePlan
    }
    totalItems
  }
}
    `;

/**
 * __useGetPaginatedOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPaginatedOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
      }
export function useGetPaginatedOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
        }
export function useGetPaginatedOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>(GetPaginatedOrganizationsDocument, options);
        }
export type GetPaginatedOrganizationsQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsQuery>;
export type GetPaginatedOrganizationsLazyQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsLazyQuery>;
export type GetPaginatedOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedOrganizationsSuspenseQuery>;
export type GetPaginatedOrganizationsQueryResult = Apollo.QueryResult<GetPaginatedOrganizationsQuery, GetPaginatedOrganizationsQueryVariables>;
export const UploadDocumentsDocument = gql`
    mutation UploadDocuments($userId: ID!, $roleId: ID!, $organizationId: ID!, $documents: [UploadDocumentsRequest]) {
  uploadDocuments(
    userId: $userId
    roleId: $roleId
    organizationId: $organizationId
    documents: $documents
  ) {
    success
    message
  }
}
    `;
export type UploadDocumentsMutationFn = Apollo.MutationFunction<UploadDocumentsMutation, UploadDocumentsMutationVariables>;

/**
 * __useUploadDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentsMutation, { data, loading, error }] = useUploadDocumentsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useUploadDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentsMutation, UploadDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentsMutation, UploadDocumentsMutationVariables>(UploadDocumentsDocument, options);
      }
export type UploadDocumentsMutationHookResult = ReturnType<typeof useUploadDocumentsMutation>;
export type UploadDocumentsMutationResult = Apollo.MutationResult<UploadDocumentsMutation>;
export type UploadDocumentsMutationOptions = Apollo.BaseMutationOptions<UploadDocumentsMutation, UploadDocumentsMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($userId: ID!, $roleId: ID!, $documentId: ID!) {
  deleteDocument(userId: $userId, roleId: $roleId, documentId: $documentId) {
    success
    message
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($userId: ID!, $roleId: ID!, $documentId: ID!, $title: String!, $s3Location: String!, $s3Key: String!, $s3Bucket: String!, $filePath: String!) {
  updateDocument(
    userId: $userId
    roleId: $roleId
    documentId: $documentId
    title: $title
    s3Location: $s3Location
    s3Key: $s3Key
    s3Bucket: $s3Bucket
    filePath: $filePath
  ) {
    success
    message
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      documentId: // value for 'documentId'
 *      title: // value for 'title'
 *      s3Location: // value for 's3Location'
 *      s3Key: // value for 's3Key'
 *      s3Bucket: // value for 's3Bucket'
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UpdateDocumentFilePathDocument = gql`
    mutation updateDocumentFilePath($documentId: ID!, $filePath: String!) {
  updateDocumentFilePath(documentId: $documentId, filePath: $filePath) {
    success
    message
  }
}
    `;
export type UpdateDocumentFilePathMutationFn = Apollo.MutationFunction<UpdateDocumentFilePathMutation, UpdateDocumentFilePathMutationVariables>;

/**
 * __useUpdateDocumentFilePathMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentFilePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentFilePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentFilePathMutation, { data, loading, error }] = useUpdateDocumentFilePathMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useUpdateDocumentFilePathMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentFilePathMutation, UpdateDocumentFilePathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentFilePathMutation, UpdateDocumentFilePathMutationVariables>(UpdateDocumentFilePathDocument, options);
      }
export type UpdateDocumentFilePathMutationHookResult = ReturnType<typeof useUpdateDocumentFilePathMutation>;
export type UpdateDocumentFilePathMutationResult = Apollo.MutationResult<UpdateDocumentFilePathMutation>;
export type UpdateDocumentFilePathMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentFilePathMutation, UpdateDocumentFilePathMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: UserRegistrationInput!) {
  registerUser(input: $input) {
    data
    message
    success
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const SaveTeamDocument = gql`
    mutation SaveTeam($userId: ID!, $roleId: ID!, $input: SaveTeamInput) {
  saveTeam(userId: $userId, roleId: $roleId, input: $input) {
    success
  }
}
    `;
export type SaveTeamMutationFn = Apollo.MutationFunction<SaveTeamMutation, SaveTeamMutationVariables>;

/**
 * __useSaveTeamMutation__
 *
 * To run a mutation, you first call `useSaveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTeamMutation, { data, loading, error }] = useSaveTeamMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTeamMutation(baseOptions?: Apollo.MutationHookOptions<SaveTeamMutation, SaveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTeamMutation, SaveTeamMutationVariables>(SaveTeamDocument, options);
      }
export type SaveTeamMutationHookResult = ReturnType<typeof useSaveTeamMutation>;
export type SaveTeamMutationResult = Apollo.MutationResult<SaveTeamMutation>;
export type SaveTeamMutationOptions = Apollo.BaseMutationOptions<SaveTeamMutation, SaveTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($userId: ID!, $roleId: ID!, $teamId: ID!) {
  deleteTeam(userId: $userId, roleId: $roleId, teamId: $teamId) {
    success
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const AddUserToTeamDocument = gql`
    mutation AddUserToTeam($userId: ID!, $roleId: ID!, $teamId: ID!, $organizationId: ID!, $userIdToAdd: ID!, $isManager: Boolean) {
  addUserToTeam(
    userId: $userId
    roleId: $roleId
    teamId: $teamId
    organizationId: $organizationId
    userIdToAdd: $userIdToAdd
    isManager: $isManager
  ) {
    success
  }
}
    `;
export type AddUserToTeamMutationFn = Apollo.MutationFunction<AddUserToTeamMutation, AddUserToTeamMutationVariables>;

/**
 * __useAddUserToTeamMutation__
 *
 * To run a mutation, you first call `useAddUserToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToTeamMutation, { data, loading, error }] = useAddUserToTeamMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      teamId: // value for 'teamId'
 *      organizationId: // value for 'organizationId'
 *      userIdToAdd: // value for 'userIdToAdd'
 *      isManager: // value for 'isManager'
 *   },
 * });
 */
export function useAddUserToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToTeamMutation, AddUserToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToTeamMutation, AddUserToTeamMutationVariables>(AddUserToTeamDocument, options);
      }
export type AddUserToTeamMutationHookResult = ReturnType<typeof useAddUserToTeamMutation>;
export type AddUserToTeamMutationResult = Apollo.MutationResult<AddUserToTeamMutation>;
export type AddUserToTeamMutationOptions = Apollo.BaseMutationOptions<AddUserToTeamMutation, AddUserToTeamMutationVariables>;
export const RemoveUserFromTeamDocument = gql`
    mutation RemoveUserFromTeam($userId: ID!, $roleId: ID!, $teamId: ID!, $userIdToRemove: ID!) {
  removeUserFromTeam(
    userId: $userId
    roleId: $roleId
    teamId: $teamId
    userIdToRemove: $userIdToRemove
  ) {
    success
  }
}
    `;
export type RemoveUserFromTeamMutationFn = Apollo.MutationFunction<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;

/**
 * __useRemoveUserFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromTeamMutation, { data, loading, error }] = useRemoveUserFromTeamMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      teamId: // value for 'teamId'
 *      userIdToRemove: // value for 'userIdToRemove'
 *   },
 * });
 */
export function useRemoveUserFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>(RemoveUserFromTeamDocument, options);
      }
export type RemoveUserFromTeamMutationHookResult = ReturnType<typeof useRemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationResult = Apollo.MutationResult<RemoveUserFromTeamMutation>;
export type RemoveUserFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromTeamMutation, RemoveUserFromTeamMutationVariables>;
export const PromoteOrDemoteUserInTeamDocument = gql`
    mutation PromoteOrDemoteUserInTeam($userId: ID!, $roleId: ID!, $teamId: ID!, $organizationId: ID!, $userIdToUpdate: ID!) {
  promoteOrDemoteUserInTeam(
    userId: $userId
    roleId: $roleId
    teamId: $teamId
    organizationId: $organizationId
    userIdToUpdate: $userIdToUpdate
  ) {
    success
  }
}
    `;
export type PromoteOrDemoteUserInTeamMutationFn = Apollo.MutationFunction<PromoteOrDemoteUserInTeamMutation, PromoteOrDemoteUserInTeamMutationVariables>;

/**
 * __usePromoteOrDemoteUserInTeamMutation__
 *
 * To run a mutation, you first call `usePromoteOrDemoteUserInTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteOrDemoteUserInTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteOrDemoteUserInTeamMutation, { data, loading, error }] = usePromoteOrDemoteUserInTeamMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      teamId: // value for 'teamId'
 *      organizationId: // value for 'organizationId'
 *      userIdToUpdate: // value for 'userIdToUpdate'
 *   },
 * });
 */
export function usePromoteOrDemoteUserInTeamMutation(baseOptions?: Apollo.MutationHookOptions<PromoteOrDemoteUserInTeamMutation, PromoteOrDemoteUserInTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteOrDemoteUserInTeamMutation, PromoteOrDemoteUserInTeamMutationVariables>(PromoteOrDemoteUserInTeamDocument, options);
      }
export type PromoteOrDemoteUserInTeamMutationHookResult = ReturnType<typeof usePromoteOrDemoteUserInTeamMutation>;
export type PromoteOrDemoteUserInTeamMutationResult = Apollo.MutationResult<PromoteOrDemoteUserInTeamMutation>;
export type PromoteOrDemoteUserInTeamMutationOptions = Apollo.BaseMutationOptions<PromoteOrDemoteUserInTeamMutation, PromoteOrDemoteUserInTeamMutationVariables>;
export const TransferTeamOwnerShipDocument = gql`
    mutation TransferTeamOwnerShip($userId: ID!, $roleId: ID!, $newOwnerId: ID!, $teamId: ID!) {
  transferTeamOwnership(
    userId: $userId
    roleId: $roleId
    newOwnerId: $newOwnerId
    teamId: $teamId
  ) {
    success
  }
}
    `;
export type TransferTeamOwnerShipMutationFn = Apollo.MutationFunction<TransferTeamOwnerShipMutation, TransferTeamOwnerShipMutationVariables>;

/**
 * __useTransferTeamOwnerShipMutation__
 *
 * To run a mutation, you first call `useTransferTeamOwnerShipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferTeamOwnerShipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferTeamOwnerShipMutation, { data, loading, error }] = useTransferTeamOwnerShipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      newOwnerId: // value for 'newOwnerId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTransferTeamOwnerShipMutation(baseOptions?: Apollo.MutationHookOptions<TransferTeamOwnerShipMutation, TransferTeamOwnerShipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferTeamOwnerShipMutation, TransferTeamOwnerShipMutationVariables>(TransferTeamOwnerShipDocument, options);
      }
export type TransferTeamOwnerShipMutationHookResult = ReturnType<typeof useTransferTeamOwnerShipMutation>;
export type TransferTeamOwnerShipMutationResult = Apollo.MutationResult<TransferTeamOwnerShipMutation>;
export type TransferTeamOwnerShipMutationOptions = Apollo.BaseMutationOptions<TransferTeamOwnerShipMutation, TransferTeamOwnerShipMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($userId: ID!, $roleId: ID!, $userIdToDelete: ID!) {
  deleteUser(userId: $userId, roleId: $roleId, userIdToDelete: $userIdToDelete) {
    success
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      userIdToDelete: // value for 'userIdToDelete'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const RemoveUserFromOrganisationDocument = gql`
    mutation removeUserFromOrganisation($userId: ID!, $organisationId: ID!) {
  removeUserFromOrganisation(userId: $userId, organisationId: $organisationId) {
    data
    message
    success
  }
}
    `;
export type RemoveUserFromOrganisationMutationFn = Apollo.MutationFunction<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>;

/**
 * __useRemoveUserFromOrganisationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganisationMutation, { data, loading, error }] = useRemoveUserFromOrganisationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useRemoveUserFromOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>(RemoveUserFromOrganisationDocument, options);
      }
export type RemoveUserFromOrganisationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganisationMutation>;
export type RemoveUserFromOrganisationMutationResult = Apollo.MutationResult<RemoveUserFromOrganisationMutation>;
export type RemoveUserFromOrganisationMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromOrganisationMutation, RemoveUserFromOrganisationMutationVariables>;
export const DeleteProgramDocument = gql`
    mutation DeleteProgram($userId: ID!, $roleId: ID!, $programId: ID!) {
  deleteProgram(userId: $userId, roleId: $roleId, programId: $programId) {
    data
    message
    success
  }
}
    `;
export type DeleteProgramMutationFn = Apollo.MutationFunction<DeleteProgramMutation, DeleteProgramMutationVariables>;

/**
 * __useDeleteProgramMutation__
 *
 * To run a mutation, you first call `useDeleteProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramMutation, { data, loading, error }] = useDeleteProgramMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useDeleteProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramMutation, DeleteProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramMutation, DeleteProgramMutationVariables>(DeleteProgramDocument, options);
      }
export type DeleteProgramMutationHookResult = ReturnType<typeof useDeleteProgramMutation>;
export type DeleteProgramMutationResult = Apollo.MutationResult<DeleteProgramMutation>;
export type DeleteProgramMutationOptions = Apollo.BaseMutationOptions<DeleteProgramMutation, DeleteProgramMutationVariables>;
export const SaveTaskDocument = gql`
    mutation SaveTask($userId: ID!, $roleId: ID!, $organizationId: ID!, $input: SaveTaskInput) {
  saveTask(
    userId: $userId
    roleId: $roleId
    organizationId: $organizationId
    input: $input
  ) {
    success
  }
}
    `;
export type SaveTaskMutationFn = Apollo.MutationFunction<SaveTaskMutation, SaveTaskMutationVariables>;

/**
 * __useSaveTaskMutation__
 *
 * To run a mutation, you first call `useSaveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTaskMutation, { data, loading, error }] = useSaveTaskMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveTaskMutation, SaveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTaskMutation, SaveTaskMutationVariables>(SaveTaskDocument, options);
      }
export type SaveTaskMutationHookResult = ReturnType<typeof useSaveTaskMutation>;
export type SaveTaskMutationResult = Apollo.MutationResult<SaveTaskMutation>;
export type SaveTaskMutationOptions = Apollo.BaseMutationOptions<SaveTaskMutation, SaveTaskMutationVariables>;
export const AddTaskClipboardDocument = gql`
    mutation AddTaskClipboard($data: [AddTaskClipboardInput]) {
  addTaskClipboard(data: $data) {
    success
  }
}
    `;
export type AddTaskClipboardMutationFn = Apollo.MutationFunction<AddTaskClipboardMutation, AddTaskClipboardMutationVariables>;

/**
 * __useAddTaskClipboardMutation__
 *
 * To run a mutation, you first call `useAddTaskClipboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskClipboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskClipboardMutation, { data, loading, error }] = useAddTaskClipboardMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddTaskClipboardMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskClipboardMutation, AddTaskClipboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskClipboardMutation, AddTaskClipboardMutationVariables>(AddTaskClipboardDocument, options);
      }
export type AddTaskClipboardMutationHookResult = ReturnType<typeof useAddTaskClipboardMutation>;
export type AddTaskClipboardMutationResult = Apollo.MutationResult<AddTaskClipboardMutation>;
export type AddTaskClipboardMutationOptions = Apollo.BaseMutationOptions<AddTaskClipboardMutation, AddTaskClipboardMutationVariables>;
export const SaveTaskDetailsDocument = gql`
    mutation SaveTaskDetails($userId: ID!, $roleId: ID!, $organizationId: ID!, $stsOrganisationId: ID!, $input: SaveTaskDetailsInput) {
  saveTaskDetails(
    userId: $userId
    roleId: $roleId
    organizationId: $organizationId
    stsOrganisationId: $stsOrganisationId
    input: $input
  ) {
    success
  }
}
    `;
export type SaveTaskDetailsMutationFn = Apollo.MutationFunction<SaveTaskDetailsMutation, SaveTaskDetailsMutationVariables>;

/**
 * __useSaveTaskDetailsMutation__
 *
 * To run a mutation, you first call `useSaveTaskDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTaskDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTaskDetailsMutation, { data, loading, error }] = useSaveTaskDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      organizationId: // value for 'organizationId'
 *      stsOrganisationId: // value for 'stsOrganisationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTaskDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTaskDetailsMutation, SaveTaskDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTaskDetailsMutation, SaveTaskDetailsMutationVariables>(SaveTaskDetailsDocument, options);
      }
export type SaveTaskDetailsMutationHookResult = ReturnType<typeof useSaveTaskDetailsMutation>;
export type SaveTaskDetailsMutationResult = Apollo.MutationResult<SaveTaskDetailsMutation>;
export type SaveTaskDetailsMutationOptions = Apollo.BaseMutationOptions<SaveTaskDetailsMutation, SaveTaskDetailsMutationVariables>;
export const UpdateTaskInstanceResetFlagDocument = gql`
    mutation UpdateTaskInstanceResetFlag($taskInstanceId: ID!) {
  updateTaskInstanceResetFlag(taskInstanceId: $taskInstanceId) {
    success
  }
}
    `;
export type UpdateTaskInstanceResetFlagMutationFn = Apollo.MutationFunction<UpdateTaskInstanceResetFlagMutation, UpdateTaskInstanceResetFlagMutationVariables>;

/**
 * __useUpdateTaskInstanceResetFlagMutation__
 *
 * To run a mutation, you first call `useUpdateTaskInstanceResetFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskInstanceResetFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskInstanceResetFlagMutation, { data, loading, error }] = useUpdateTaskInstanceResetFlagMutation({
 *   variables: {
 *      taskInstanceId: // value for 'taskInstanceId'
 *   },
 * });
 */
export function useUpdateTaskInstanceResetFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskInstanceResetFlagMutation, UpdateTaskInstanceResetFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskInstanceResetFlagMutation, UpdateTaskInstanceResetFlagMutationVariables>(UpdateTaskInstanceResetFlagDocument, options);
      }
export type UpdateTaskInstanceResetFlagMutationHookResult = ReturnType<typeof useUpdateTaskInstanceResetFlagMutation>;
export type UpdateTaskInstanceResetFlagMutationResult = Apollo.MutationResult<UpdateTaskInstanceResetFlagMutation>;
export type UpdateTaskInstanceResetFlagMutationOptions = Apollo.BaseMutationOptions<UpdateTaskInstanceResetFlagMutation, UpdateTaskInstanceResetFlagMutationVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($userId: ID!, $roleId: ID!, $taskId: ID!) {
  deleteTask(userId: $userId, roleId: $roleId, taskId: $taskId) {
    success
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const ValidateIntegrationUserDocument = gql`
    mutation ValidateIntegrationUser($organizationId: ID!) {
  validateIntegrationUser(organizationId: $organizationId) {
    isExist
    message
  }
}
    `;
export type ValidateIntegrationUserMutationFn = Apollo.MutationFunction<ValidateIntegrationUserMutation, ValidateIntegrationUserMutationVariables>;

/**
 * __useValidateIntegrationUserMutation__
 *
 * To run a mutation, you first call `useValidateIntegrationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateIntegrationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateIntegrationUserMutation, { data, loading, error }] = useValidateIntegrationUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useValidateIntegrationUserMutation(baseOptions?: Apollo.MutationHookOptions<ValidateIntegrationUserMutation, ValidateIntegrationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateIntegrationUserMutation, ValidateIntegrationUserMutationVariables>(ValidateIntegrationUserDocument, options);
      }
export type ValidateIntegrationUserMutationHookResult = ReturnType<typeof useValidateIntegrationUserMutation>;
export type ValidateIntegrationUserMutationResult = Apollo.MutationResult<ValidateIntegrationUserMutation>;
export type ValidateIntegrationUserMutationOptions = Apollo.BaseMutationOptions<ValidateIntegrationUserMutation, ValidateIntegrationUserMutationVariables>;
export const UserSettingsDocument = gql`
    query UserSettings($userId: ID!, $organizationId: ID) {
  userSettings(userId: $userId, organizationId: $organizationId) {
    id
    createdAt
    organizationId
    settingKey
    settingValue
    updatedAt
    userId
  }
}
    `;

/**
 * __useUserSettingsQuery__
 *
 * To run a query within a React component, call `useUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUserSettingsQuery(baseOptions: Apollo.QueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables> & ({ variables: UserSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
      }
export function useUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
        }
export function useUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSettingsQuery, UserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSettingsQuery, UserSettingsQueryVariables>(UserSettingsDocument, options);
        }
export type UserSettingsQueryHookResult = ReturnType<typeof useUserSettingsQuery>;
export type UserSettingsLazyQueryHookResult = ReturnType<typeof useUserSettingsLazyQuery>;
export type UserSettingsSuspenseQueryHookResult = ReturnType<typeof useUserSettingsSuspenseQuery>;
export type UserSettingsQueryResult = Apollo.QueryResult<UserSettingsQuery, UserSettingsQueryVariables>;
export const UpsertUserSettingDocument = gql`
    mutation UpsertUserSetting($userId: ID!, $settingKey: String!, $settingValue: String!, $userSettingId: ID, $organizationId: ID!) {
  upsertUserSetting(
    userId: $userId
    settingKey: $settingKey
    settingValue: $settingValue
    userSettingId: $userSettingId
    organizationId: $organizationId
  ) {
    message
    success
  }
}
    `;
export type UpsertUserSettingMutationFn = Apollo.MutationFunction<UpsertUserSettingMutation, UpsertUserSettingMutationVariables>;

/**
 * __useUpsertUserSettingMutation__
 *
 * To run a mutation, you first call `useUpsertUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSettingMutation, { data, loading, error }] = useUpsertUserSettingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      settingKey: // value for 'settingKey'
 *      settingValue: // value for 'settingValue'
 *      userSettingId: // value for 'userSettingId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpsertUserSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSettingMutation, UpsertUserSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSettingMutation, UpsertUserSettingMutationVariables>(UpsertUserSettingDocument, options);
      }
export type UpsertUserSettingMutationHookResult = ReturnType<typeof useUpsertUserSettingMutation>;
export type UpsertUserSettingMutationResult = Apollo.MutationResult<UpsertUserSettingMutation>;
export type UpsertUserSettingMutationOptions = Apollo.BaseMutationOptions<UpsertUserSettingMutation, UpsertUserSettingMutationVariables>;
export const UpsertUserSettingsDocument = gql`
    mutation UpsertUserSettings($settings: [UserSettingsInput]!) {
  upsertUserSettings(settings: $settings) {
    message
    success
  }
}
    `;
export type UpsertUserSettingsMutationFn = Apollo.MutationFunction<UpsertUserSettingsMutation, UpsertUserSettingsMutationVariables>;

/**
 * __useUpsertUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSettingsMutation, { data, loading, error }] = useUpsertUserSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpsertUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSettingsMutation, UpsertUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSettingsMutation, UpsertUserSettingsMutationVariables>(UpsertUserSettingsDocument, options);
      }
export type UpsertUserSettingsMutationHookResult = ReturnType<typeof useUpsertUserSettingsMutation>;
export type UpsertUserSettingsMutationResult = Apollo.MutationResult<UpsertUserSettingsMutation>;
export type UpsertUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertUserSettingsMutation, UpsertUserSettingsMutationVariables>;
export const UserOrganizationsDocument = gql`
    query UserOrganizations($userId: ID!) {
  userOrganizations(userId: $userId) {
    organization {
      id
      name
      stsOrganisationId
      logo
      category
      defaultLanguage
    }
    isActive
  }
}
    `;

/**
 * __useUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOrganizationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables> & ({ variables: UserOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
      }
export function useUserOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
export function useUserOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
export type UserOrganizationsQueryHookResult = ReturnType<typeof useUserOrganizationsQuery>;
export type UserOrganizationsLazyQueryHookResult = ReturnType<typeof useUserOrganizationsLazyQuery>;
export type UserOrganizationsSuspenseQueryHookResult = ReturnType<typeof useUserOrganizationsSuspenseQuery>;
export type UserOrganizationsQueryResult = Apollo.QueryResult<UserOrganizationsQuery, UserOrganizationsQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($currentPage: Int, $pageSize: Int, $filter: CategoryFilter) {
  categories(currentPage: $currentPage, pageSize: $pageSize, filter: $filter) {
    categories {
      id
      name
      type
    }
    totalItems
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const SaveCategoryDocument = gql`
    mutation SaveCategory($categoryId: ID, $input: SaveCategoryInput) {
  saveCategory(categoryId: $categoryId, input: $input) {
    data
    message
    success
  }
}
    `;
export type SaveCategoryMutationFn = Apollo.MutationFunction<SaveCategoryMutation, SaveCategoryMutationVariables>;

/**
 * __useSaveCategoryMutation__
 *
 * To run a mutation, you first call `useSaveCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCategoryMutation, { data, loading, error }] = useSaveCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCategoryMutation(baseOptions?: Apollo.MutationHookOptions<SaveCategoryMutation, SaveCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCategoryMutation, SaveCategoryMutationVariables>(SaveCategoryDocument, options);
      }
export type SaveCategoryMutationHookResult = ReturnType<typeof useSaveCategoryMutation>;
export type SaveCategoryMutationResult = Apollo.MutationResult<SaveCategoryMutation>;
export type SaveCategoryMutationOptions = Apollo.BaseMutationOptions<SaveCategoryMutation, SaveCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($categoryId: ID!) {
  deleteCategory(categoryId: $categoryId) {
    data
    message
    success
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const SaveStarterProgramDocument = gql`
    mutation SaveStarterProgram($input: SaveStarterProgramInput) {
  saveStarterProgram(input: $input) {
    data
    message
    success
  }
}
    `;
export type SaveStarterProgramMutationFn = Apollo.MutationFunction<SaveStarterProgramMutation, SaveStarterProgramMutationVariables>;

/**
 * __useSaveStarterProgramMutation__
 *
 * To run a mutation, you first call `useSaveStarterProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveStarterProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveStarterProgramMutation, { data, loading, error }] = useSaveStarterProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveStarterProgramMutation(baseOptions?: Apollo.MutationHookOptions<SaveStarterProgramMutation, SaveStarterProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveStarterProgramMutation, SaveStarterProgramMutationVariables>(SaveStarterProgramDocument, options);
      }
export type SaveStarterProgramMutationHookResult = ReturnType<typeof useSaveStarterProgramMutation>;
export type SaveStarterProgramMutationResult = Apollo.MutationResult<SaveStarterProgramMutation>;
export type SaveStarterProgramMutationOptions = Apollo.BaseMutationOptions<SaveStarterProgramMutation, SaveStarterProgramMutationVariables>;
export const DeleteStarterProgramDocument = gql`
    mutation deleteStarterProgram($id: ID!) {
  deleteStarterProgram(id: $id) {
    data
    message
    success
  }
}
    `;
export type DeleteStarterProgramMutationFn = Apollo.MutationFunction<DeleteStarterProgramMutation, DeleteStarterProgramMutationVariables>;

/**
 * __useDeleteStarterProgramMutation__
 *
 * To run a mutation, you first call `useDeleteStarterProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStarterProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStarterProgramMutation, { data, loading, error }] = useDeleteStarterProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStarterProgramMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStarterProgramMutation, DeleteStarterProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStarterProgramMutation, DeleteStarterProgramMutationVariables>(DeleteStarterProgramDocument, options);
      }
export type DeleteStarterProgramMutationHookResult = ReturnType<typeof useDeleteStarterProgramMutation>;
export type DeleteStarterProgramMutationResult = Apollo.MutationResult<DeleteStarterProgramMutation>;
export type DeleteStarterProgramMutationOptions = Apollo.BaseMutationOptions<DeleteStarterProgramMutation, DeleteStarterProgramMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($organizationId: ID!) {
  deleteOrganization(organizationId: $organizationId) {
    data
    message
    success
  }
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const ChangeStatusOrganizationDocument = gql`
    mutation changeStatusOrganization($organizationId: ID!) {
  changeStatusOrganization(organizationId: $organizationId) {
    data
    message
    success
  }
}
    `;
export type ChangeStatusOrganizationMutationFn = Apollo.MutationFunction<ChangeStatusOrganizationMutation, ChangeStatusOrganizationMutationVariables>;

/**
 * __useChangeStatusOrganizationMutation__
 *
 * To run a mutation, you first call `useChangeStatusOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStatusOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStatusOrganizationMutation, { data, loading, error }] = useChangeStatusOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useChangeStatusOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<ChangeStatusOrganizationMutation, ChangeStatusOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeStatusOrganizationMutation, ChangeStatusOrganizationMutationVariables>(ChangeStatusOrganizationDocument, options);
      }
export type ChangeStatusOrganizationMutationHookResult = ReturnType<typeof useChangeStatusOrganizationMutation>;
export type ChangeStatusOrganizationMutationResult = Apollo.MutationResult<ChangeStatusOrganizationMutation>;
export type ChangeStatusOrganizationMutationOptions = Apollo.BaseMutationOptions<ChangeStatusOrganizationMutation, ChangeStatusOrganizationMutationVariables>;
export const GeneratePresignedPutUrlDocument = gql`
    mutation GeneratePresignedPutUrl($fileName: String!, $folder: String!) {
  generatePresignedPutUrl(fileName: $fileName, folder: $folder) {
    url
    key
    location
    bucket
  }
}
    `;
export type GeneratePresignedPutUrlMutationFn = Apollo.MutationFunction<GeneratePresignedPutUrlMutation, GeneratePresignedPutUrlMutationVariables>;

/**
 * __useGeneratePresignedPutUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedPutUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedPutUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedPutUrlMutation, { data, loading, error }] = useGeneratePresignedPutUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useGeneratePresignedPutUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedPutUrlMutation, GeneratePresignedPutUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedPutUrlMutation, GeneratePresignedPutUrlMutationVariables>(GeneratePresignedPutUrlDocument, options);
      }
export type GeneratePresignedPutUrlMutationHookResult = ReturnType<typeof useGeneratePresignedPutUrlMutation>;
export type GeneratePresignedPutUrlMutationResult = Apollo.MutationResult<GeneratePresignedPutUrlMutation>;
export type GeneratePresignedPutUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedPutUrlMutation, GeneratePresignedPutUrlMutationVariables>;
export const GeneratePresignedDeleteUrlDocument = gql`
    mutation GeneratePresignedDeleteUrl($existingKey: String!) {
  generatePresignedDeleteUrl(existingKey: $existingKey) {
    url
    key
    bucket
  }
}
    `;
export type GeneratePresignedDeleteUrlMutationFn = Apollo.MutationFunction<GeneratePresignedDeleteUrlMutation, GeneratePresignedDeleteUrlMutationVariables>;

/**
 * __useGeneratePresignedDeleteUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedDeleteUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedDeleteUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedDeleteUrlMutation, { data, loading, error }] = useGeneratePresignedDeleteUrlMutation({
 *   variables: {
 *      existingKey: // value for 'existingKey'
 *   },
 * });
 */
export function useGeneratePresignedDeleteUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedDeleteUrlMutation, GeneratePresignedDeleteUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedDeleteUrlMutation, GeneratePresignedDeleteUrlMutationVariables>(GeneratePresignedDeleteUrlDocument, options);
      }
export type GeneratePresignedDeleteUrlMutationHookResult = ReturnType<typeof useGeneratePresignedDeleteUrlMutation>;
export type GeneratePresignedDeleteUrlMutationResult = Apollo.MutationResult<GeneratePresignedDeleteUrlMutation>;
export type GeneratePresignedDeleteUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedDeleteUrlMutation, GeneratePresignedDeleteUrlMutationVariables>;
export const GeneratePresignedGetUrlDocument = gql`
    mutation GeneratePresignedGetUrl($existingKey: String!) {
  generatePresignedGetUrl(existingKey: $existingKey) {
    url
    key
    bucket
  }
}
    `;
export type GeneratePresignedGetUrlMutationFn = Apollo.MutationFunction<GeneratePresignedGetUrlMutation, GeneratePresignedGetUrlMutationVariables>;

/**
 * __useGeneratePresignedGetUrlMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedGetUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedGetUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedGetUrlMutation, { data, loading, error }] = useGeneratePresignedGetUrlMutation({
 *   variables: {
 *      existingKey: // value for 'existingKey'
 *   },
 * });
 */
export function useGeneratePresignedGetUrlMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedGetUrlMutation, GeneratePresignedGetUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedGetUrlMutation, GeneratePresignedGetUrlMutationVariables>(GeneratePresignedGetUrlDocument, options);
      }
export type GeneratePresignedGetUrlMutationHookResult = ReturnType<typeof useGeneratePresignedGetUrlMutation>;
export type GeneratePresignedGetUrlMutationResult = Apollo.MutationResult<GeneratePresignedGetUrlMutation>;
export type GeneratePresignedGetUrlMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedGetUrlMutation, GeneratePresignedGetUrlMutationVariables>;
export const ReorderIncludedTasksDocument = gql`
    mutation ReorderIncludedTasks($userId: ID!, $roleId: ID!, $programId: ID!, $taskOrders: [TaskOrderInput!]!) {
  reorderIncludedTasks(
    userId: $userId
    roleId: $roleId
    programId: $programId
    taskOrders: $taskOrders
  ) {
    success
    message
  }
}
    `;
export type ReorderIncludedTasksMutationFn = Apollo.MutationFunction<ReorderIncludedTasksMutation, ReorderIncludedTasksMutationVariables>;

/**
 * __useReorderIncludedTasksMutation__
 *
 * To run a mutation, you first call `useReorderIncludedTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderIncludedTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderIncludedTasksMutation, { data, loading, error }] = useReorderIncludedTasksMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roleId: // value for 'roleId'
 *      programId: // value for 'programId'
 *      taskOrders: // value for 'taskOrders'
 *   },
 * });
 */
export function useReorderIncludedTasksMutation(baseOptions?: Apollo.MutationHookOptions<ReorderIncludedTasksMutation, ReorderIncludedTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderIncludedTasksMutation, ReorderIncludedTasksMutationVariables>(ReorderIncludedTasksDocument, options);
      }
export type ReorderIncludedTasksMutationHookResult = ReturnType<typeof useReorderIncludedTasksMutation>;
export type ReorderIncludedTasksMutationResult = Apollo.MutationResult<ReorderIncludedTasksMutation>;
export type ReorderIncludedTasksMutationOptions = Apollo.BaseMutationOptions<ReorderIncludedTasksMutation, ReorderIncludedTasksMutationVariables>;